import React, {
  lazy,
  Suspense,
  useCallback,
  useContext,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useNetworkStatus } from "../../context/NetworkContext";
import NetworkStatusPopup from "./MessageBoxTypes/NCXComponents/NetworkStatusPopup";
import uuid from "react-uuid";
import Cookies from "js-cookie";
import DOMPurify from "dompurify";
import { Snackbar } from "@material-ui/core";
import CircularProgress from "@mui/material/CircularProgress";
import dayjs from "dayjs";
import DummyAgentImage from "../../images/DummyAgent.svg";
import { supportedFileFormats } from "../../utils/Constants/Constants";
import ReloadSessionContainer from "../../utils/ReloadSessionContainer/ReloadSessionContainer";
import DefaultFooter from "../CommonUtils/DefaultFooter";
import HWLog from "../HWLibrary/HWLog";
import apiService from "../Services/APIService";
import { sendNotification } from "../Services/HWIframeBridge";
import { s360ConfigService } from "../Services/S360Config";
import xmppService from "../Services/XMPPService";
import { Home, HomeOutlined } from "@mui/icons-material";
import { ConvoType, MessageType } from "./MessageBoxTypes/Message";
import Conversation from "./Conversation";
import ConversationHeader from "./ConversationHeader";
import InputBox from "./InputBox";
import Popup from "./Popup";
import { usePrimaryIdentification } from "../../context/PrimaryIdentificationContext";
import SendChatTranscriptForm from "./SendChatTranscriptForm";

import "./ConversationStyleSheet.css";
import "react-modal-overlay/dist/index.css";

import TermsAndCondition from "./TermsAndConditions/TermsAndCondition";
import NCXCloseConversation from "./NCXCloseConversation/NCXCloseConversation";

import { dummyMesages } from "./ConversationConstants";
import { LoaderContext, LoaderProviderWrapper } from "./utils/loaderContext";

import defaultBrandIcon from "../../utils/Icons/DefaultBrandIcon";

import flowMemorySingleton from "../Services/FlowMemorySingleton";
import {
  DATA_TEST_ID_PREFIX,
  DATA_TEST_ID_PREFIX_CONNECT_TO_NEXTIVA,
  LIVECHAT_CLICK_EVENTS,
  LIVECHAT_LOG_ACTIONS,
  LIVECHAT_LOG_EVENTS,
  LIVECHAT_LOG_KEYS,
} from "../../utils/Constants/statsig.constants";
import { filterByLatestWorkitemId, isValidJSON } from "./utils/historyUtils";
import NCXPrivacyPolicyCompact from "./MessageBoxTypes/NCXComponents/NCXPrivacyPolicyCompact";
import {
  analyzeMessages,
  getCookieForContactDetails,
  removeCookieForContactDetails,
} from "./utils/ConversationUtils";
import { statsigLogEvent } from "@nextiva/ncx-feature-management";
import { playNotificationSoundRobust } from "../../utils/audioPlayback";

const NCXChatHistoryLazy = lazy(() => import("./NCXChatHistory"));

let tempFilesArray = [];
const messageStatuses = {
  DELIVERED: "DELIVERED",
  READ: "READ",
};
let internetListenerAdded = false;

let healthPingCounter = 0;
let agentNotificationMessageIds = [];
let agentNotificationMessageIdsCopy = [];
let messageToBeUpdatedForStatus = new Map();
let failedMessageStatusUpdates = new Map(); // messageId -> { statuses: string[], workitemId: string }
let loopMessagerecived = false;

function ConversationPage(props) {
  const { isOnline, networkQuality, latency } = useNetworkStatus();
  const [workitemIdArrays, setWorkitemIdArrays] = useState([]);
  // Deduplicate history fetches when deps resolve to same values across quick re-renders
  const lastHistoryFetchKeyRef = useRef(null);
  const latestWorkitemIdRef = useRef(props.conversation?.workitemId || null);
  const latestTrackedWorkitemId = useMemo(
    () =>
      workitemIdArrays.length > 0
        ? workitemIdArrays[workitemIdArrays.length - 1]
        : null,
    [workitemIdArrays],
  );
  const messageRef = useRef();
  const file = useRef();
  const [messages, setMessages] = useState([]);
  const preventHistory = useRef(false);
  const [previewSessionID, setPreviewSessionID] = useState(
    s360ConfigService?.config?.previewSessionId,
  );
  const currentWorkitemId = useMemo(
    () =>
      props.conversation?.workitemId ||
      latestTrackedWorkitemId ||
      latestWorkitemIdRef.current ||
      s360ConfigService.resumedWorkitemId ||
      null,
    [props.conversation?.workitemId, latestTrackedWorkitemId],
  );

  const [xmppMessageHistory, setXmppMessageHistory] = useState([]);
  const [previewFiles, setPreviewFiles] = useState([]);
  const [isConversationClosed, setIsConversationClosed] = useState(false);
  const [showSnackBar, setShowSnackBar] = useState(false);
  const [showSendChatTranscriptForm, setShowSendChatTranscriptForm] =
    useState(false);

  const [showCloseDialog, setShowCloseDialog] = useState(false);
  const [chatClosedExternally, setChatClosedExternally] = useState(false);
  const [isFetchingMessages, setIsFetchingMessages] = useState(false);
  const [isReset, setIsReset] = useState(false);
  const [showText, setShowText] = useState(false);
  const [showGif, setShowGif] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [finalValue] = useState(null);
  const [previousWorkitemId, setPreviousWorkitemId] = useState(null);
  const [messageLoader, setMessageLoader] = useState(false);
  const [isFetchingMessagesBelow, setIsFetchingMessagesBelow] = useState(false);
  const [showChatStatusLang, setShowChatStatusLang] = useState(
    props?.config?.chatStatusLangtoggle || true,
  );
  const [showChatStatusAttachment, setShowChatStatusAttachment] =
    useState(false);
  const [disableLoader] = useState(false);
  const [terminatedDueToTimeout, setTerminatedDueToTimeout] = useState(false);
  const [historyFetched, setHistoryFetched] = useState(false);
  const [customerAckObj] = useState({});
  const [showAckMsg, setShowAckMsg] = useState(false);
  const [setMsgValue, setSetMsgValue] = useState({});
  const [showReloadPopup, setShowReloadPopup] = useState(false);
  const [showLoaderBotPopup, setShowLoaderBotPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const [agentPingStatus, setAgentPingStatus] = useState();
  const [showMessagesFromStart, setShowMessagesFromStart] = useState(false);
  const [snackBarMessage, setSnackBarMesssage] = useState("");
  const [fileSizeError, setFileSizeError] = useState("");
  const [open, setOpen] = useState(false);
  const [isTyping, setIsTyping] = useState(false);
  const [sessionClosedbyAgent, setSessionClosedbyAgent] = useState(false);
  const [closedBySystemTimeout, setClosedBySystemTimeout] = useState(false);
  const [playSound, setPlaySound] = useState(false);
  const [enableAttachment, setEnableAttachment] = useState(
    s360ConfigService.agentConnected,
  );
  const [isAgentConnected, setIsAgentConnected] = useState(
    s360ConfigService.agentConnected || false,
  );
  const [acceptedPrivacy, setAcceptedPrivacy] = useState(
    localStorage.getItem(
      `nextiva-widget-terms-acceptance-${s360ConfigService?.config?.widgetconfigId}`,
    ) === "true",
  );
  const { primaryIdentification } = usePrimaryIdentification();
  const [fileParams, setFileParams] = useState({});
  const [inputSpecs, setInputSpecs] = useState({});
  const isFullScreen = localStorage.getItem("openInFullScreen");
  const [showInputBox, setShowInputBox] = useState(
    s360ConfigService.config.showInputBox ?? true,
  );
  const [hideInputForHisry, setHideInputForHistory] = useState(false);
  const [isAiBot, setIsAiBot] = useState(false);
  // const [termsAccepted, setTermsAccepted] = useState(
  //   !s360ConfigService.config.preview &&
  //     Cookies.get(
  //       `nextiva-widget-terms-acceptance-${s360ConfigService?.config?.widgetconfigId}`
  //     )
  // );
  const [showNcxChatHistory, setShowNcxChatHistory] = useState(false);
  const targetRef = useRef();
  const historyRequestIdRef = useRef(0);
  const focusReloadTimestampRef = useRef(0);
  const focusReloadInFlightRef = useRef(false);
  const silentHistoryReloadRef = useRef(null);
  const historyAgentStatusUpdateCacheRef = useRef(new Set());
  const pendingAgentStatusUpdatesRef = useRef(new Set());
  const agentStatusRetryCountRef = useRef(0);
  const MAX_AGENT_STATUS_RETRIES = 3;
  const allowSilentRefreshRef = useRef(true);
  const terminatedWorkitemIdRef = useRef(null);

  const [downloadInProgress, setDownloadInProgress] = useState(false);
  const [downloadHistoryStep, setDownloadHistoryStep] = useState({
    step: 0,
    historyWorkItemId: "",
    activeMessages: [],
    ticketId: "",
  });
  const [sendingAttachmentsLoader, setSendingAttachementsLoader] =
    useState(false);
  const [showProcessingAttachementLoader, setShowProcessingAttachementLoader] =
    useState(false);

  // const { setLoader } = useContext(LoaderContext);
  const [downloadChatTranscriptStep, setDownloadChatTranscriptStep] =
    useState(0);
  const [isWindowActive, setIsWindowActive] = useState(document.hasFocus());
  const windowActiveRef = useRef(document.hasFocus());
  const windowWasHiddenRef = useRef(document.visibilityState === "hidden");
  const visibilityRefreshTimeoutRef = useRef(null);
  let audio = null;
  if (
    s360ConfigService.config?.notification?.audio !== undefined &&
    s360ConfigService.config?.notification?.audio !== null
  ) {
    audio = new Audio();
    //use getAudio from APiservice
    //response is blob
    //   getAudio() {
    //   if (
    //     !s360ConfigService?.config?.location ||
    //     !s360ConfigService?.config?.notification?.audio
    //   ) {
    //     console.error(
    //       "APIService Error: Missing configuration for getAudio (location or audio)."
    //     );
    //     return Promise.reject(new Error("Missing configuration for getAudio"));
    //   }
    //   const url = `${s360ConfigService.config.location}/lioncc/${s360ConfigService.config.notification.audio}`;
    //   return axios.get(url, { responseType: "blob" });
    // }
    //this is the function call
    // apiService.getAudio().then((response) => {
    //   audio.src = URL.createObjectURL(response.data);
    // });

    // audio.src = `${s360ConfigService.config?.location}/lioncc/${s360ConfigService.config?.notification?.audio}`;
  }
  let defaultMessage = "Type a message...";
  let loaderTimeOut = 0;

  let clearMsgIds = {};

  const onlineEventMap = new Map();
  const wasOfflineRef = useRef(false);

  // Handle network status changes
  useEffect(() => {}, [isOnline]);
  useEffect(() => {
    if (messages.length > 0) {
      props.setBackupMessages(messages);
    }
  }, [messages]);
  useEffect(() => {
    const handleAgentConnected = () => {
      setIsAgentConnected(true);
    };

    window.addEventListener("agentConnected", handleAgentConnected);

    return () => {
      window.removeEventListener("agentConnected", handleAgentConnected);
    };
  }, []);
  const handleNetworkReload = useCallback(() => {
    if (currentWorkitemId) {
      preventHistory.current = false;
      s360ConfigService.config.historyMessages = false;
      setShowLoaderBotPopup(true);

      // Use this api to get ticket id first
      apiService
        .getCurrentTicketId(currentWorkitemId)
        .then((data) => {
          let ticketId = null;
          if (
            data?.data?.length > 0 &&
            data?.data[data?.data?.length - 1]?.parentTicketId
          ) {
            ticketId = data?.data[data?.data?.length - 1]?.parentTicketId;
          }

          // Only proceed if we have a ticketId
          if (ticketId) {
            console.log("ticket id is present");
            // Call the same history fetch that happens on minimize/maximize
            fetchAndPopulateHistory(
              ticketId,
              currentWorkitemId,
              () => {},
              true,
            );

            // 🚀 SAFE WebSocket Reconnection - Only after history fetch
            setTimeout(() => {
              if (props.actions?.safeReconnectWebSocket && currentWorkitemId) {
                console.log(
                  "Network reload: Attempting safe WebSocket reconnection for workitem:",
                  currentWorkitemId,
                );
                props.actions.safeReconnectWebSocket(currentWorkitemId, true);
              } else if (
                props.actions?.startInitChatWSConnection &&
                currentWorkitemId
              ) {
                console.log(
                  "Network reload: Fallback to WebSocket connection for workitem:",
                  currentWorkitemId,
                );
                // Fallback to existing method (it already has safeguards)
                props.actions.startInitChatWSConnection(
                  currentWorkitemId,
                  true,
                );
              }
            }, 500); // Small delay to ensure history fetch completes first
          } else {
            console.error("No ticketId found for network reload");
            setShowLoaderBotPopup(false);
          }
        })
        .catch((err) => {
          console.error("Error getting ticketId:", err);
          setShowLoaderBotPopup(false);
        });
    }
  }, [currentWorkitemId, props.actions, fetchAndPopulateHistory]);
  function addConnectionListeners(workitemId, handleConnectionChange) {
    // If a listener for this workitem already exists, remove it
    if (onlineEventMap.has(workitemId)) {
      const { onlineListener, offlineListener } =
        onlineEventMap.get(workitemId);
      window.removeEventListener("online", onlineListener);
      window.removeEventListener("offline", offlineListener);
      onlineEventMap.delete(workitemId);
    }

    // Define new listeners
    const onlineListener = () => handleConnectionChange(workitemId);
    const offlineListener = () => handleConnectionChange(workitemId);

    // Add new listeners
    window.addEventListener("online", onlineListener);
    window.addEventListener("offline", offlineListener);

    // Store them in the map for future removal
    onlineEventMap.set(workitemId, { onlineListener, offlineListener });
  }

  const eventAccessiblePlaySound = useRef(playSound);
  useEffect(() => {
    if (s360ConfigService.config?.sandBox) {
      setMessages([...dummyMesages]);
    }
  }, [s360ConfigService.config]);
  useEffect(() => {
    // console.log("isOnline changed:", isOnline, props.backupMessages);
    if (currentWorkitemId) {
      latestWorkitemIdRef.current = currentWorkitemId;
      setWorkitemIdArrays((prev) => {
        if (prev[prev.length - 1] === currentWorkitemId) {
          return prev;
        }
        return [...prev, currentWorkitemId];
      });
      s360ConfigService.resumedWorkitemId = currentWorkitemId;
      s360ConfigService.config.workitemId = currentWorkitemId;
      if (preventHistory.current) {
        preventHistory.current = false;
      }
    }

    if (props.isAppOpen && !s360ConfigService.config?.sandBox) {
      if (currentWorkitemId) {
        localStorage.getItem("isLoggedIn");
        addConnectionListeners(currentWorkitemId, handleConnectionChange);
      }

      setShowLoaderBotPopup(true);
      const timeoutId = setTimeout(() => {
        setShowLoaderBotPopup(false);
      }, 4000);

      return () => clearTimeout(timeoutId);
    }
  }, [props.isAppOpen, currentWorkitemId]);
  useEffect(() => {
    eventAccessiblePlaySound.current = playSound;
  }, [playSound]);

  useEffect(() => {
    historyAgentStatusUpdateCacheRef.current.clear();
    pendingAgentStatusUpdatesRef.current.clear();
    agentStatusRetryCountRef.current = 0;
    // Clear message status maps when workitem changes - old workitem statuses are irrelevant
    messageToBeUpdatedForStatus.clear();
    failedMessageStatusUpdates.clear();
    console.log("[MessageStatus] Maps cleared on workitem change", {
      currentWorkitemId,
    });
  }, [currentWorkitemId]);

  useEffect(() => {
    if (!currentWorkitemId) {
      return;
    }

    if (
      terminatedWorkitemIdRef.current &&
      terminatedWorkitemIdRef.current !== currentWorkitemId
    ) {
      allowSilentRefreshRef.current = true;
      terminatedWorkitemIdRef.current = null;
    }
  }, [currentWorkitemId]);

  const triggerSilentRefreshIfEligible = useCallback((reason) => {
    if (!windowWasHiddenRef.current) {
      return false;
    }

    if (document.visibilityState !== "visible") {
      return false;
    }

    windowWasHiddenRef.current = false;
    console.log(`[FocusRefresh] ${reason} triggered refresh`, {
      hasFocus: document.hasFocus(),
    });
    silentHistoryReloadRef.current?.();
    return true;
  }, []);

  const scheduleVisibilityRefreshAttempt = useCallback(() => {
    if (!windowWasHiddenRef.current) {
      return;
    }

    if (visibilityRefreshTimeoutRef.current) {
      clearTimeout(visibilityRefreshTimeoutRef.current);
    }

    visibilityRefreshTimeoutRef.current = setTimeout(() => {
      visibilityRefreshTimeoutRef.current = null;
      if (!windowWasHiddenRef.current) {
        return;
      }
      const triggered = triggerSilentRefreshIfEligible(
        "Deferred visibility change",
      );
      if (!triggered && document.visibilityState === "visible") {
        scheduleVisibilityRefreshAttempt();
      }
    }, 150);
  }, [triggerSilentRefreshIfEligible]);

  const flushAgentStatusUpdates = useCallback(() => {
    if (!currentWorkitemId || !isOnline) {
      return;
    }

    const candidateIds = [];
    const invalidIds = [];

    pendingAgentStatusUpdatesRef.current.forEach((messageId) => {
      if (!messageId) {
        invalidIds.push(messageId);
        return;
      }
      if (!historyAgentStatusUpdateCacheRef.current.has(messageId)) {
        candidateIds.push(messageId);
        historyAgentStatusUpdateCacheRef.current.add(messageId);
      }
    });

    invalidIds.forEach((messageId) => {
      pendingAgentStatusUpdatesRef.current.delete(messageId);
    });

    if (candidateIds.length === 0) {
      return;
    }

    candidateIds.forEach((messageId) => {
      pendingAgentStatusUpdatesRef.current.delete(messageId);
    });

    console.log("[HistoryStatus] Promoting agent messages to delivered/read", {
      workitemId: currentWorkitemId,
      count: candidateIds.length,
    });

    const updatePromises = candidateIds.map((messageId) =>
      apiService
        .updateMessageStatus(currentWorkitemId, messageId, [
          messageStatuses.DELIVERED,
          messageStatuses.READ,
        ])
        .then(() => ({ messageId, success: true }))
        .catch((error) => ({
          messageId,
          success: false,
          error,
        }))
        .finally(() => {
          historyAgentStatusUpdateCacheRef.current.delete(messageId);
        }),
    );

    Promise.all(updatePromises).then((results) => {
      const failures = results.filter((result) => !result.success);
      const successes = results.length - failures.length;

      failures.forEach(({ messageId, error }) => {
        console.error("[HistoryStatus] Failed to promote agent message", {
          workitemId: currentWorkitemId,
          messageId,
          error,
        });
        if (messageId) {
          pendingAgentStatusUpdatesRef.current.add(messageId);
        }
      });

      if (successes > 0) {
        console.log("[HistoryStatus] Agent messages promoted", {
          workitemId: currentWorkitemId,
          count: successes,
        });
      }

      if (pendingAgentStatusUpdatesRef.current.size > 0) {
        if (failures.length > 0) {
          agentStatusRetryCountRef.current += 1;
          if (agentStatusRetryCountRef.current > MAX_AGENT_STATUS_RETRIES) {
            console.warn(
              "[HistoryStatus] Max retries reached for agent status updates, giving up.",
              {
                workitemId: currentWorkitemId,
                pendingCount: pendingAgentStatusUpdatesRef.current.size,
              },
            );
            pendingAgentStatusUpdatesRef.current.clear();
            historyAgentStatusUpdateCacheRef.current.clear();
            agentStatusRetryCountRef.current = 0;
            return;
          }
          const retryDelay = Math.min(
            2000 * Math.pow(2, agentStatusRetryCountRef.current - 1),
            16000,
          );
          console.log(
            `[HistoryStatus] Scheduling retry ${agentStatusRetryCountRef.current}/${MAX_AGENT_STATUS_RETRIES} in ${retryDelay}ms`,
          );
          setTimeout(() => flushAgentStatusUpdates(), retryDelay);
        } else {
          agentStatusRetryCountRef.current = 0;
          flushAgentStatusUpdates();
        }
      } else {
        agentStatusRetryCountRef.current = 0;
      }
    });
  }, [currentWorkitemId, isOnline]);

  const queueAgentStatusUpdates = useCallback(
    (messageIds) => {
      if (!Array.isArray(messageIds) || messageIds.length === 0) {
        return;
      }

      let added = false;
      messageIds.forEach((messageId) => {
        if (!messageId) {
          return;
        }
        if (historyAgentStatusUpdateCacheRef.current.has(messageId)) {
          return;
        }
        if (!pendingAgentStatusUpdatesRef.current.has(messageId)) {
          pendingAgentStatusUpdatesRef.current.add(messageId);
          added = true;
        }
      });

      if (added) {
        flushAgentStatusUpdates();
      }
    },
    [flushAgentStatusUpdates],
  );

  const updateHistoryAgentMessageStatuses = useCallback(
    (messageIds) => {
      queueAgentStatusUpdates(messageIds);
    },
    [queueAgentStatusUpdates],
  );

  const deriveMessageIdentifier = useCallback((message) => {
    const rawId =
      message?.id ??
      message?.messageId ??
      message?.clientMessageId ??
      message?.uid ??
      message?.message?.id ??
      message?.message?.messageId ??
      message?.message?.clientMessageId ??
      message?.message?.uid ??
      message?.message?.message?.id ??
      message?.message?.message?.messageId ??
      message?.message?.message?.clientMessageId ??
      message?.message?.message?.uid ??
      null;

    // Normalize ID by removing common prefixes to prevent duplicates
    if (!rawId) return null;

    const idStr = String(rawId);

    // Remove common prefixes
    let normalizedId = idStr;
    if (normalizedId.startsWith("reply_"))
      normalizedId = normalizedId.substring(6);
    if (normalizedId.startsWith("chat_"))
      normalizedId = normalizedId.substring(5);

    // For attachment messages with multiple files, strip the _0, _1, etc. suffix
    // to treat them as the same base message for deduplication
    // Example: 7b2b1450-dc3e-432c-933c-5a8058f0eaf4_0 -> 7b2b1450-dc3e-432c-933c-5a8058f0eaf4
    const underscoreIndex = normalizedId.lastIndexOf("_");
    if (underscoreIndex > 0) {
      const suffix = normalizedId.substring(underscoreIndex + 1);
      // Only strip if suffix is a single digit (attachment index)
      if (/^\d$/.test(suffix)) {
        normalizedId = normalizedId.substring(0, underscoreIndex);
      }
    }

    return normalizedId;
  }, []);

  const deriveMessageTimestamp = useCallback(
    (message, fallbackSequence = 0) => {
      const candidates = [
        message?.message?.sentTimestamp,
        message?.message?.timestamp,
        message?.message?.timeStamp,
        message?.message?.createdTime,
        message?.message?.createdAt,
        message?.message?.updatedAt,
        message?.message?.sentTime,
        message?.timestamp,
        message?.createdAt,
        message?.sentTimestamp,
        message?.message?.message?.sentTimestamp,
      ];

      for (const candidate of candidates) {
        if (candidate === undefined || candidate === null) {
          continue;
        }
        const numeric = Number(candidate);
        if (!Number.isNaN(numeric)) {
          return numeric;
        }
        const parsed = Date.parse(candidate);
        if (!Number.isNaN(parsed)) {
          return parsed;
        }
      }

      return Number.MAX_SAFE_INTEGER;
    },
    [],
  );

  const mergeMessagesPreservingOrder = useCallback(
    (baseMessages, incomingMessages, { shouldSort = false } = {}) => {
      if (
        (!baseMessages || baseMessages.length === 0) &&
        (!incomingMessages || incomingMessages.length === 0)
      ) {
        return [];
      }

      const indexMap = new Map();
      const mergedRecords = [];
      let sequenceCounter = 0;

      const pushMessage = (message) => {
        if (!message) {
          return;
        }

        const key = deriveMessageIdentifier(message);
        const recordTimestamp = deriveMessageTimestamp(
          message,
          sequenceCounter,
        );

        if (!key) {
          mergedRecords.push({
            message,
            timestamp: recordTimestamp,
            seq: sequenceCounter++,
          });
          return;
        }

        const existing = indexMap.get(key);
        if (!existing) {
          const record = {
            message,
            timestamp: recordTimestamp,
            seq: sequenceCounter++,
          };
          indexMap.set(key, record);
          mergedRecords.push(record);
          return;
        }

        existing.timestamp = Math.min(existing.timestamp, recordTimestamp);

        const mergedMessage = {
          ...message,
          ...existing.message,
          sentTimestamp: existing.timestamp,
          timestamp: existing.timestamp,
          message: (() => {
            const historyPayload = message?.message;
            const existingPayload = existing.message?.message;

            if (
              historyPayload &&
              typeof historyPayload === "object" &&
              !Array.isArray(historyPayload)
            ) {
              const normalizedExisting =
                existingPayload &&
                typeof existingPayload === "object" &&
                !Array.isArray(existingPayload)
                  ? existingPayload
                  : {};

              return {
                ...historyPayload,
                ...normalizedExisting,
                sentTimestamp: existing.timestamp,
              };
            }

            return existingPayload ?? historyPayload ?? null;
          })(),
        };

        if (
          Array.isArray(message?.messageStatus) &&
          message.messageStatus.length > 0
        ) {
          mergedMessage.messageStatus = message.messageStatus;
        }

        existing.message = mergedMessage;
      };

      baseMessages?.forEach(pushMessage);
      incomingMessages?.forEach(pushMessage);

      if (shouldSort) {
        mergedRecords.sort((a, b) => {
          if (a.timestamp === b.timestamp) {
            return a.seq - b.seq;
          }
          return a.timestamp - b.timestamp;
        });
      }

      return mergedRecords
        .map((entry) => entry.message)
        .filter((message) => message !== undefined && message !== null);
    },
    [deriveMessageIdentifier, deriveMessageTimestamp],
  );

  useEffect(() => {
    if (isOnline) {
      flushAgentStatusUpdates();

      // Retry failed real-time message status updates when coming back online
      // Only retry for current workitem - drop stale entries
      if (failedMessageStatusUpdates.size > 0) {
        const entries = [...failedMessageStatusUpdates.entries()];
        const staleEntries = entries.filter(
          ([, { workitemId }]) => workitemId !== currentWorkitemId,
        );
        staleEntries.forEach(([messageId]) => {
          console.log(
            `[MessageStatus] Dropping stale entry ${messageId} (old workitem)`,
          );
          failedMessageStatusUpdates.delete(messageId);
        });

        const currentEntries = entries.filter(
          ([, { workitemId }]) => workitemId === currentWorkitemId,
        );
        if (currentEntries.length > 0) {
          console.log(
            "[MessageStatus] Retrying failed status updates on reconnect",
            {
              count: currentEntries.length,
            },
          );
          currentEntries.forEach(([messageId, { statuses, workitemId }]) => {
            apiService
              .updateMessageStatus(workitemId, messageId, statuses)
              .then(() => {
                console.log(`[MessageStatus] Retry success for ${messageId}`);
                failedMessageStatusUpdates.delete(messageId);
              })
              .catch((error) => {
                console.warn(
                  `[MessageStatus] Retry still failing for ${messageId}:`,
                  error,
                );
              });
          });
        }
      }
    }
  }, [isOnline, flushAgentStatusUpdates]);

  useEffect(() => {
    const handleAutoReconnect = (event) => {
      console.log(
        "[FocusRefresh] Auto websocket reconnect triggered refresh",
        event?.detail,
      );
      silentHistoryReloadRef.current?.();
    };

    window.addEventListener("chatWSReconnected", handleAutoReconnect);
    return () =>
      window.removeEventListener("chatWSReconnected", handleAutoReconnect);
  }, []);

  useEffect(() => {
    const handleVisibilityChange = () => {
      const isVisible = document.visibilityState === "visible";
      const hasFocus = document.hasFocus();
      windowActiveRef.current = isVisible && hasFocus;
      setIsWindowActive(isVisible && hasFocus);

      if (!isVisible) {
        windowWasHiddenRef.current = true;
        if (visibilityRefreshTimeoutRef.current) {
          clearTimeout(visibilityRefreshTimeoutRef.current);
          visibilityRefreshTimeoutRef.current = null;
        }
        return;
      }

      if (triggerSilentRefreshIfEligible("Visibility change")) {
        return;
      }

      if (!windowWasHiddenRef.current) {
        return;
      }

      scheduleVisibilityRefreshAttempt();
    };

    const handleFocus = () => {
      windowActiveRef.current = true;
      setIsWindowActive(true);

      if (visibilityRefreshTimeoutRef.current) {
        clearTimeout(visibilityRefreshTimeoutRef.current);
        visibilityRefreshTimeoutRef.current = null;
      }

      triggerSilentRefreshIfEligible("Window focus");
    };

    const handleBlur = () => {
      windowActiveRef.current = false;
      setIsWindowActive(false);

      if (document.visibilityState === "hidden") {
        windowWasHiddenRef.current = true;
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    window.addEventListener("focus", handleFocus);
    window.addEventListener("blur", handleBlur);

    return () => {
      setWorkitemIdArrays([]);
      latestWorkitemIdRef.current = null;
      s360ConfigService.resumedWorkitemId = null;
      onlineEventMap.forEach(({ onlineListener, offlineListener }) => {
        window.removeEventListener("online", onlineListener);
        window.removeEventListener("offline", offlineListener);
      });
      onlineEventMap.clear();
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("focus", handleFocus);
      window.removeEventListener("blur", handleBlur);
      if (visibilityRefreshTimeoutRef.current) {
        clearTimeout(visibilityRefreshTimeoutRef.current);
        visibilityRefreshTimeoutRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    return () => {
      // Cancel outstanding history requests on unmount
      historyRequestIdRef.current += 1;
    };
  }, []);

  useEffect(() => {
    window.addEventListener(
      "EngagementDataStatusUpdateNotification",
      onEngagementDataStatusUpdateNotification,
    );
    return () => {
      window.removeEventListener(
        "EngagementDataStatusUpdateNotification",
        onEngagementDataStatusUpdateNotification,
      );
    };
  }, []);
  const handleEditMessage = useCallback((workitemId, messageId, newText) => {
    let originalMessage;
    setMessages((prevMessages) => {
      return prevMessages.map((message) => {
        if (message.id === messageId) {
          originalMessage = message;
          // Deeply clone the message object to avoid mutating state directly
          const updatedMessage = { ...message };

          // Handle different message types: CUSTOM vs. plain text
          if (updatedMessage.messageType === "PRIVATE_MESSAGE") {
            try {
              let messageContent =
                typeof updatedMessage.message === "string"
                  ? JSON.parse(updatedMessage.message)
                  : updatedMessage.message;
              if (
                messageContent &&
                messageContent.components &&
                Array.isArray(messageContent.components)
              ) {
                messageContent.components = messageContent.components.map(
                  (component) => {
                    // Don't update the input buttons, only text elements
                    if (component.type === "text") {
                      return {
                        ...component,
                        text: newText,
                        richText: `<p class="lexicalEditor-paragraph" dir="ltr" style="margin: 0; position: relative; margin-bottom: 0;"><span style="white-space: pre-wrap">${newText}</span></p>`, // Also update richText to match
                      };
                    }
                    return component; // return the unchanged component if not a text component
                  },
                );
              }

              // Assign the modified messageContent back.  Stringify it if it was originally a string.
              updatedMessage.message =
                typeof message.message === "string"
                  ? JSON.stringify(messageContent)
                  : messageContent;
              updatedMessage.isEdited = true;
            } catch (error) {
              console.error("Error parsing or updating CUSTOM message:", error);
              message.message = newText;
              message.isEdited = true;

              return message; // return original message if there's a parsing error
            }
          } else {
            // Handle plain text messages (messageMediaType !== "CUSTOM").  Directly change updatedMessage.message
            updatedMessage.message = newText;
            updatedMessage.isEdited = true;
          }

          return updatedMessage; // return the updated message
        } else {
          return message; // Return the unchanged message if the ID doesn't match
        }
      });
    });

    // Call the API
    apiService
      .editMessage(workitemId, messageId, newText)
      .then(() => {
        console.warn("Message edited successfully.");
      })
      .catch((error) => {
        console.error("Failed to edit message:", error);

        // Revert the optimistic update on error
        setMessages((prevMessages) =>
          prevMessages.map((msg) =>
            msg.id === messageId ? originalMessage : msg,
          ),
        );

        // Optionally show an error to the user
      });
  }, []);

  const handleDeleteMessage = useCallback((workitemId, messageId) => {
    let originalMessage;

    // Optimistically mark the message as deleted
    setMessages((prevMessages) => {
      return prevMessages.map((message) => {
        if (message.id === messageId) {
          originalMessage = { ...message }; // store for rollback
          return { ...message, isDeleted: true };
        }
        return message;
      });
    });

    // Call the API to delete the message
    apiService
      .deleteMessage(workitemId, messageId)
      .then(() => {})
      .catch((error) => {
        console.error("Failed to delete message:", error);

        // Revert the deletion on error
        setMessages((prevMessages) =>
          prevMessages.map((msg) =>
            msg.id === messageId ? originalMessage : msg,
          ),
        );

        // Optionally notify user of the failure
      });
  }, []);

  const memoizedMessage = useMemo(() => {
    return {
      sendMessageToPreview: props.sendMessageToPreview,
      isLatestMessage: false,
      uploadFilesToPreview: props.uploadFilesToPreview,
      lastMessageIndex: "",
      currentMessageIndex: "",
      messageID: "",
      setEnableAttachmentProp: () => {},
      setFileParamsProp: () => {},
      id: "",
      downloadInProgress: false,
      setInputSpecsProp: () => {},
      message: {},
    };
  }, []);
  const onEngagementDataStatusUpdateNotification = useCallback(
    ({ detail: body }) => {
      const cleanEngagementDataUid = body.engagementDataUid?.startsWith("chat_")
        ? body.engagementDataUid.substring(5)
        : body.engagementDataUid;

      if (!cleanEngagementDataUid) {
        console.warn("cleanEngagementDataUid is null or undefined. Skipping.");
        return;
      }

      setMessages((prevMessages) => {
        // Normalize ID for comparison - remove common prefixes
        const normalizeId = (id) => {
          if (!id) return null;
          const idStr = String(id);
          if (idStr.startsWith("reply_")) return idStr.substring(6);
          if (idStr.startsWith("chat_")) return idStr.substring(5);
          return idStr;
        };

        const normalizedTargetId = normalizeId(cleanEngagementDataUid);

        if (!normalizedTargetId) {
          console.warn("Normalized target ID is null. Skipping.");
          return prevMessages;
        }

        // Find all messages that match the target ID
        // This handles both direct matches and attachment indices (id, id_0, id_1, etc.)
        const messagesToUpdate = [];

        prevMessages.forEach((msg, index) => {
          const normalizedMsgId = normalizeId(msg?.id);
          if (!normalizedMsgId) return;

          // Direct match
          if (normalizedMsgId === normalizedTargetId) {
            messagesToUpdate.push(index);
            return;
          }

          // Check if the message ID is in format: targetId_0, targetId_1, etc.
          // This handles multiple attachments for the same message
          if (normalizedMsgId.startsWith(normalizedTargetId + "_")) {
            messagesToUpdate.push(index);
            return;
          }

          // Legacy support: check for old format with trailing 0 (numeric IDs only)
          // For backward compatibility with old messages stored as id + 0
          if (
            /^\d+0$/.test(normalizedMsgId) &&
            normalizedMsgId.slice(0, -1) === normalizedTargetId
          ) {
            messagesToUpdate.push(index);
          }
        });

        if (messagesToUpdate.length > 0) {
          // Check if any message actually needs updating
          let hasChanges = false;
          const updatedMessages = [...prevMessages];

          messagesToUpdate.forEach((index) => {
            const existingMessage = updatedMessages[index];
            const existingStatus = JSON.stringify(
              existingMessage.messageStatus || [],
            );
            const newStatus = JSON.stringify(
              body.engagementDataPayloadList || [],
            );

            if (existingStatus !== newStatus) {
              updatedMessages[index] = {
                ...existingMessage,
                messageStatus: body.engagementDataPayloadList,
              };
              hasChanges = true;
            }
          });

          if (hasChanges) {
            console.log(
              `[StatusUpdate] Updated ${messagesToUpdate.length} message(s) with base ID ${normalizedTargetId}`,
            );
            return updatedMessages;
          }

          // No changes needed
          return prevMessages;
        } else {
          console.warn(
            `[StatusUpdate] Message with ID ${cleanEngagementDataUid} (normalized: ${normalizedTargetId}) not found for status update.`,
          );
          return prevMessages;
        }
      });
    },
    [],
  );

  useEffect(() => {
    if (props.isAppOpen && props.chatStatus) {
      //setMessages([]);
    }
  }, [props.isAppOpen, props.chatStatus]);

  useEffect(() => {
    if (props.isAppOpen && isWindowActive) {
      const workitemId = currentWorkitemId || s360ConfigService?.workItemId;

      // Promote DELIVERED → READ for tracked messages (only current workitem)
      if (messageToBeUpdatedForStatus.size) {
        const messageIdsToRead = [];

        messageToBeUpdatedForStatus.forEach((value, key) => {
          if (value === messageStatuses.DELIVERED) {
            messageIdsToRead.push(key);
          }
        });

        if (messageIdsToRead.length > 0) {
          console.log("[MessageStatus] Promoting DELIVERED→READ on maximize", {
            count: messageIdsToRead.length,
            workitemId,
          });
        }

        messageIdsToRead.forEach((id) => {
          apiService
            .updateMessageStatus(workitemId, id, [messageStatuses.READ])
            .then(() => {
              console.log(`[MessageStatus] ${id} promoted to READ`);
              failedMessageStatusUpdates.delete(id);
            })
            .catch((error) => {
              console.error(
                `[MessageStatus] Failed to promote ${id} to READ:`,
                error,
              );
              failedMessageStatusUpdates.set(id, {
                statuses: [messageStatuses.READ],
                workitemId,
              });
            });
          messageToBeUpdatedForStatus.set(id, messageStatuses.READ);
        });
      }

      // Retry any previously failed status updates — only for current workitem
      if (failedMessageStatusUpdates.size > 0) {
        // Drop stale entries for old workitems
        const entries = [...failedMessageStatusUpdates.entries()];
        const staleEntries = entries.filter(
          ([, { workitemId: wid }]) => wid !== workitemId,
        );
        staleEntries.forEach(([messageId]) => {
          console.log(
            `[MessageStatus] Dropping stale failed entry ${messageId} (old workitem)`,
          );
          failedMessageStatusUpdates.delete(messageId);
        });

        const currentEntries = entries.filter(
          ([, { workitemId: wid }]) => wid === workitemId,
        );
        if (currentEntries.length > 0) {
          console.log("[MessageStatus] Retrying failed updates on maximize", {
            count: currentEntries.length,
          });
          currentEntries.forEach(
            ([messageId, { statuses, workitemId: failedWid }]) => {
              const targetStatuses = statuses.includes(messageStatuses.READ)
                ? statuses
                : [messageStatuses.DELIVERED, messageStatuses.READ];
              apiService
                .updateMessageStatus(
                  failedWid || workitemId,
                  messageId,
                  targetStatuses,
                )
                .then(() => {
                  console.log(`[MessageStatus] Retry success for ${messageId}`);
                  failedMessageStatusUpdates.delete(messageId);
                  messageToBeUpdatedForStatus.set(
                    messageId,
                    messageStatuses.READ,
                  );
                })
                .catch((error) => {
                  console.warn(
                    `[MessageStatus] Retry still failing for ${messageId}:`,
                    error,
                  );
                });
            },
          );
        }
      }
    }
  }, [props.isAppOpen, isWindowActive]);

  const onMessageFromThrio = useCallback(
    ({ detail: body }) => {
      // Check if message is from AI EMPLOYEE and enable AI bot mode
      if (body?.messageSubType === "AIEMPLOYEE") {
        setIsAiBot(true);
        console.log(
          "AI Employee message detected. Input box will remain enabled.",
        );
      }

      if (body?.id) {
        const isUserActive = props.isAppOpen && isWindowActive;

        const statusList = isUserActive
          ? [messageStatuses.DELIVERED, messageStatuses.READ]
          : [messageStatuses.DELIVERED];

        const workitemId = isUserActive
          ? currentWorkitemId
          : s360ConfigService?.workItemId;

        apiService
          .updateMessageStatus(workitemId, body.id, statusList)
          .then(() => {
            console.log(
              `[MessageStatus] ${body.id} updated to ${statusList.join(",")}`,
            );
            failedMessageStatusUpdates.delete(body.id);
          })
          .catch((error) => {
            console.warn(`[MessageStatus] Failed to update ${body.id}:`, error);
            failedMessageStatusUpdates.set(body.id, {
              statuses: statusList,
              workitemId,
            });
          });
        messageToBeUpdatedForStatus.set(
          body.id,
          isUserActive ? messageStatuses.READ : messageStatuses.DELIVERED,
        );
      }

      // setLoader(false);

      if (s360ConfigService.config.notification.isEnabled) {
        playNotificationSoundRobust(
          s360ConfigService.config.notification.audio,
        );
      }
      if (props.config.configDetails?.browserNotification) {
        if (body.userType === "BOT") {
          sendNotification("Message from Bot");
        }
        if (body.userType === "AGENT") {
          if (body.message) {
            sendNotification(body.message);
          } else {
            sendNotification(
              `Message from ${s360ConfigService?.config?.configDetails?.brandName} Agent`,
            );
          }
        }
      }

      setHideInputForHistory(false);
      addMessagesToList([body]);
      preventHistory.current = false;
    },
    [
      props.isAppOpen,
      isWindowActive,
      currentWorkitemId,
      props.config.configDetails?.browserNotification,
    ],
  );

  // Event listener for message notifications
  useEffect(() => {
    window.addEventListener("MessageNotification", onMessageFromThrio);
    return () => {
      window.removeEventListener("MessageNotification", onMessageFromThrio);
    };
  }, [onMessageFromThrio]);

  const onWorkitemTerminated = (data) => {
    allowSilentRefreshRef.current = false;
    terminatedWorkitemIdRef.current = currentWorkitemId;

    const closedBy = data?.detail?.workitem?.data?.closedBy;
    setChatClosedExternally(true);
    if (["SystemTimeout", "AGENT"].includes(closedBy)) {
      const { isBotEnabled, isAiBot, hasImageAttached } =
        analyzeMessages(messages);
      const isAgentStarted = flowMemorySingleton.getAgentMessageStarted();

      const basePayload = {
        [LIVECHAT_LOG_KEYS.action]: isAgentStarted
          ? LIVECHAT_LOG_ACTIONS.CLOSE_CHAT_WITH_AGENT
          : LIVECHAT_LOG_ACTIONS.CLOSE_CHAT_WITHOUT_AGENT,
        [LIVECHAT_LOG_KEYS.widgetConfigId]:
          s360ConfigService?.config?.widgetconfigId,
        [LIVECHAT_LOG_KEYS.campaignId]: s360ConfigService?.config?.campaignId,
        [LIVECHAT_LOG_KEYS.timeStamp]: Date.now(),
        [LIVECHAT_LOG_KEYS.sessionId]: props.activeConversation?.sessionId,
        [LIVECHAT_LOG_KEYS.isBotEnabled]: isBotEnabled,
        [LIVECHAT_LOG_KEYS.isAIBot]: isAiBot,
        [LIVECHAT_LOG_KEYS.hasImageAttached]: hasImageAttached,
        [LIVECHAT_LOG_KEYS.FAQArticleClicked]:
          localStorage.getItem("FAQ_Article_Clicked") === "true",
        isChatSessionTimedOut: true,
        isChatClosedByAgent: closedBy === "AGENT",
      };
      let eventName;

      if (s360ConfigService?.config?.connectToNextiva) {
        eventName = isAgentStarted
          ? LIVECHAT_LOG_EVENTS.CONNECT_NEXTIVA_AGENT_CHAT
          : LIVECHAT_LOG_EVENTS.CONNECT_NEXTIVA_BOT_CHAT;
      } else {
        eventName = LIVECHAT_LOG_EVENTS.CLOSE_CHAT;
      }

      statsigLogEvent(eventName, basePayload);
    }

    s360ConfigService.agentConnected = false;
    setHideInputForHistory(true);
    if (closedBy === "CUSTOMER") {
      return;
    }

    // Set appropriate state based on closure reason
    setSessionClosedbyAgent(closedBy?.toLowerCase?.() === "AGENT");
    setClosedBySystemTimeout(
      closedBy?.toLowerCase() === "SYSTEM_TIMEOUT".toLowerCase(),
    );
    setShowCloseDialog(true);
    s360ConfigService.activeConversation = false;
    flowMemorySingleton.setLastShownMessageIdForAutoAttachment(false);
    if (s360ConfigService && s360ConfigService.firstUserMessageSent) {
      s360ConfigService.firstUserMessageSent = false;
    }

    // Preserve formDetails so restart chat can still derive isAnonymous correctly
    const previousFormDetails = s360ConfigService.thrioConfig?.formDetails;
    s360ConfigService.thrioConfig = {};
    if (previousFormDetails) {
      s360ConfigService.thrioConfig.formDetails = previousFormDetails;
    }
    s360ConfigService.chatHistory = null;
    // s360ConfigService.resumedWorkitemId = null;
    s360ConfigService.activeSessions = {};

    // Clear message status tracking maps - terminated workitem statuses are irrelevant
    messageToBeUpdatedForStatus.clear();
    failedMessageStatusUpdates.clear();
    console.log("[MessageStatus] Maps cleared on workitem termination");

    if (!currentWorkitemId) {
      s360ConfigService.config.isNewConversation = false;
    }

    // setMessages([]);

    // restartConversationOnClose();
    // props.actions.moveToPage(PageName.landingPage);
    // props.actions.startNewConversation();

    // if (
    //   !s360ConfigService?.config?.anonymous ||
    //   !s360ConfigService?.config?.connectToNextiva
    // ) {
    //   props.actions.moveToPage(PageName.initialForm);
    // }
  };

  useEffect(() => {
    window.addEventListener(
      "WorkitemTerminatedNotification",
      onWorkitemTerminated,
    );

    return () => {
      window.removeEventListener(
        "WorkitemTerminatedNotification",
        onWorkitemTerminated,
      );
    };
  }, []);

  useEffect(() => {
    if (props.isAppOpen) {
      return () => {
        removeHelathPingTimer();
        Object.keys(clearMsgIds).map((key) => {
          clearTimeout(clearMsgIds[key]);
        });
      };
    }
  }, [props.isAppOpen]);
  useEffect(() => {
    if (props.chatStatus) {
      if (!s360ConfigService?.config?.sandBox && !historyFetched) {
        fetchConversationHistoryCometd();
      }
    }
  }, [props.chatStatus]);

  // };
  const sendMessageToPreview = (apiText, componentId, showText) => {
    s360ConfigService.config.historyMessages = false;
    sendMessage(apiText, true, showText);
    if (s360ConfigService.config.preview) {
      setPreviewSessionID(s360ConfigService?.config?.previewSessionId);
      apiService
        .sendPreviewData(
          apiText,
          componentId,
          s360ConfigService?.config?.previewSessionId,
        )
        .then((response) => {})
        .catch((error) => {
          console.error("Error sending preview data:", error);
        });
    }
  };
  const termsAndConditionsDecider = useMemo(() => {
    const privacyPolicy =
      s360ConfigService.config?.configDetails?.privacyPolicyDetails;
    if (s360ConfigService.config.sandBox) {
      return s360ConfigService.config.privacy;
    }
    if (!privacyPolicy?.enabled) return false;

    if (privacyPolicy.type === "compact" && !acceptedPrivacy) {
      return true;
    }

    return false;
  }, [
    s360ConfigService.config?.configDetails?.privacyPolicyDetails,
    acceptedPrivacy,
    s360ConfigService.config.privacy,
  ]);

  const uploadFilesToPreview = (text, componentId, files) => {
    if (!s360ConfigService.config.preview) {
      let properties = {
        fromId: s360ConfigService.thrioConfig.formDetails.Email,
        toId: currentWorkitemId,
        type: "CLIENT",
        textMsg: text,
        configId: s360ConfigService.config._id,
      };

      if (files?.length) {
        let formData = new FormData();
        formData.append("object", JSON.stringify(properties));

        files.forEach((file, i) => {
          formData.append(`file${i + 1}`, file.file);
        });
        apiService.sendMessage(formData, currentWorkitemId);
      }
      return;
    }

    let messageAttachments = [];
    let sentTimestamp = new Date().getTime();
    const formData = new FormData();

    files.forEach((file, i) => {
      let mediaMessage = {
        message: JSON.stringify({
          components: [
            {
              type: "file",
              subType: "default",
              attachmentTitle: file.name,
              category: "display",
              sentTimestamp: sentTimestamp, // Current timestamp
              id: "chat_ " + sentTimestamp + i, // Unique ID for the message
              url: URL.createObjectURL(file),
              attachmentMimeType: file.type,
              attachmentType: isImageType(file.type),
              attachedSize: file.size,
            },
          ],
        }),
        userType: "CUSTOMER",
        messageMediaType: "CUSTOM",
        id: "chat_ " + sentTimestamp + i,
        type: MessageType.sent, // Message type
        timestamp: sentTimestamp, // Timestamp for the message
        convoType: parseFileTypeToSend(file), // Determine the type (image, video, etc.)
        creator: "CUSTOMER", // Who created the message
        createdAt: sentTimestamp,
        messageStatus: [{ status: "SENT" }], // Initialize with SENT status
      };

      messageAttachments.push(mediaMessage);

      formData.append("file", file);
    });

    // Add additional fields required by the API
    formData.append(
      "object",
      JSON.stringify({
        previewSessionId: s360ConfigService?.config?.previewSessionId, // Replace with the actual session ID
        message: {
          textMsg: text,
        },
      }),
    );

    sendMessage(text, true);
    apiService
      .sendPreviewDataFiles(formData)
      .then((response) => {})
      .catch((error) => {
        console.error("Error sending preview data:", error);
      });
    addMessagesToList(messageAttachments);
  };

  const handleFileScan = async (file) => {
    let regexforFileExtension = /(?:\.([^.]+))?$/;
    const ext = regexforFileExtension.exec(file.name)?.[0]?.toLowerCase();
    if (!ext || !supportedFileFormats.includes(ext)) {
      showSnackBarWithMessage(`${file.name} File format not supported.`);
      return;
    }

    setIsFetchingMessages(true);
    if (s360ConfigService?.config?.fileScan) {
      fetch("https://api.cloudmersive.com/virus/scan/file", {
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
          Apikey: "b05a4113-bf4d-42d3-a7b9-5506c269d6e2",
        },
        body: file,
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          setIsFetchingMessages(false);
          if (data.CleanResult) {
            tempFilesArray.push(...previewFiles, file);
            const uploadFiles = tempFilesArray.reduce(
              (accumulator, current) => {
                if (!accumulator.find((item) => item.name === current.name)) {
                  accumulator.push(current);
                }
                return accumulator;
              },
              [],
            );

            setPreviewFiles(uploadFiles);
            file.current.value = "";
          } else {
            showSnackBarWithMessage(
              `Upload blocked: Malicious file detected, for security reasons and the file is ${file.name}`,
            );
          }
        })
        .catch(() => {
          // console.error("Error in handleFileScan", error);
          setIsFetchingMessages(false);
          showSnackBarWithMessage(
            "Something went wrong, Please try some other files",
          );
        });
    } else {
      tempFilesArray.push(...previewFiles, file);
      setIsFetchingMessages(true);

      const uploadFiles = tempFilesArray.reduce((accumulator, current) => {
        if (!accumulator.find((item) => item.name === current.name)) {
          accumulator.push(current);
        }
        return accumulator;
      }, []);

      setPreviewFiles(uploadFiles);
      setIsFetchingMessages(false);
    }
  };

  const onFileSelect = async (e) => {
    if (e.target.files) {
      let files = e.target.files;
      let receivedFileSize = 0;
      for (let i = 0; i < files.length; i++) {
        receivedFileSize += files[i].size;
      }

      // sizeLimit comes from bot builder
      const DEFAULT_MAX_SIZE_MB = 20;
      const DEFAULT_MAX_SIZE_BYTES = DEFAULT_MAX_SIZE_MB * 1024 * 1024; // 20 MB in bytes

      if (fileParams?.sizeLimit && receivedFileSize <= fileParams.sizeLimit) {
        for (let i = 0; i < files.length; i++) {
          await handleFileScan(files[i]);
        }
        if (tempFilesArray.length === 0) {
          tempFilesArray = [];
        }
      } else if (
        !fileParams?.sizeLimit &&
        receivedFileSize <= DEFAULT_MAX_SIZE_BYTES
      ) {
        for (let i = 0; i < files.length; i++) {
          await handleFileScan(files[i]);
        }
        if (tempFilesArray.length === 0) {
          tempFilesArray = [];
        }
      } else {
        const convertFileSize = (size) =>
          size >= 1048576
            ? `${(size / 1048576).toFixed(2)} MB`
            : `${(size / 1024).toFixed(2)} KB`;
        const errorMsg = `Max file size limit is ${
          fileParams?.sizeLimit
            ? convertFileSize(fileParams.sizeLimit)
            : `${DEFAULT_MAX_SIZE_MB} MB`
        }`;
        setShowSnackBar(true);
        setSnackBarMesssage(errorMsg);
        setFileSizeError(errorMsg);
        setTimeout(() => setFileSizeError(""), 3000);
      }
    }
  };

  const onRemovePreviewFile = (file) => {
    let previewFileslocal = previewFiles || [];
    previewFileslocal = previewFileslocal.filter(
      (previewFile) => previewFile.name !== file.name,
    );
    tempFilesArray = [];
    setPreviewFiles(previewFileslocal);
  };

  const initialActionCometd = (conversation) => {
    if (s360ConfigService?.config?.sandBox) {
      conversation = {};
      conversation.sessionId = "1234";
      conversation.sessionStatus = "NEW";
    }
    //NOTE : Enhancement 2
    if (props?.config?.healthCheck) {
      agentHealthPingTimerId = setInterval(async () => {
        startFetchingHealthPings();
      }, 1000 * 60);
    }

    if (
      conversation?.sessionStatus === "New" &&
      parseInt(localStorage.getItem("CurrentActiveSession")) !==
        parseInt(conversation?.sessionId)
    ) {
      parseBotReplyResponse(conversation);
    } else {
      // fetchConversationHistoryCometd();
    }
    localStorage.setItem("CurrentActiveSession", conversation?.sessionId);
  };

  const disableOnAgentConnections = () => {
    sessionStorage.setItem("agentConnected", "true");
    setShowChatStatusLang(false);
    setShowChatStatusAttachment(!s360ConfigService.config.hideAttachment);
  };

  const fetchConversationHistoryCometd = (lastFetchMessageId) => {
    // if (!props.config?.anonymous) {
    //   return;
    // }
    let sessionInfo = props.activeConversation;
    setHistoryFetched(true);
  };

  // const parseCustomerMsgAck = (message) => {
  //   if (props?.config?.chatRetry) {
  //     const initialMsgArray = [];
  //     if (
  //       message &&
  //       message?.msgId &&
  //       setMsgValue.hasOwnProperty(message.msgId)
  //     ) {
  //       messages.map((el) => {
  //         let ele = { ...el };
  //         if (el.id === message.msgId) {
  //           ele.message["showSingleTick"] = true;
  //         }
  //         initialMsgArray.push(ele);
  //       });
  //
  //       setMessages(initialMsgArray);
  //     }
  //   }
  // };

  // const parseBotFromCustomerMsgAck = (message) => {
  //   if (props?.config?.chatRetry) {
  //     if (setMsgValue?.message?.showDoubleTick) {
  //       return;
  //     }

  //     let initialMsgArray = [];
  //     if (
  //       message &&
  //       message?.msgId &&
  //       setMsgValue.hasOwnProperty(message.msgId)
  //     ) {
  //       messages.map((el) => {
  //         let ele = { ...el };
  //         if (el.id === message.msgId) {
  //           ele.message["showDoubleTick"] = true;
  //           ele.message["showSingleTick"] = true;
  //           delete setMsgValue[message.msgId];
  //         }
  //         initialMsgArray.push(ele);
  //       });
  //
  //       setMessages(initialMsgArray);
  //     }
  //   }
  // };

  // const parseAckAllAgentReply = () => {
  //   let tempArray = [];
  //   if (props?.config?.chatRetry) {
  //     messages.map((el) => {
  //       let ele = { ...el };
  //       if (ele.message.showSingleTick) {
  //         ele.message.showDoubleTick = true;
  //       }
  //       tempArray.push(ele);
  //     });
  //
  //     setMessages(tempArray);
  //   }
  // };

  //NOTE : Enhancement 3
  const parseSessionReload = () => setShowReloadPopup(true);

  const parseUniboxSinleRefreshRespone = () => {
    sessionStorage.setItem("agentWaiting", "true");
    const isAgentWaiting = sessionStorage.getItem("agentWaiting");
    const isAgentConnected = sessionStorage.getItem("agentConnected");
    if (!isAgentConnected && isAgentWaiting) {
      if (s360ConfigService.config?.agentNotificationMessages?.length) {
        let tempIntervalMessages =
          s360ConfigService.config.agentNotificationMessages;
        agentNotificationMessageIds = tempIntervalMessages.map(
          (oneMessage) => oneMessage.id,
        );
        agentNotificationMessageIdsCopy = tempIntervalMessages.map(
          (oneMessage) => oneMessage.id,
        );
        tempIntervalMessages.forEach((oneIntervalMessage) =>
          createDynamicIntervals(oneIntervalMessage),
        );
      }
    }
  };

  const onMessageSend = () => {
    let isMediaAttached = (previewFiles || []).length !== 0;
    let hasTextMessage = !(
      !messageRef?.current?.value ||
      !messageRef?.current?.value.trim() ||
      messageRef?.current?.value === defaultMessage
    );
    if (!isMediaAttached && !hasTextMessage) {
      return;
    }

    if (hasTextMessage && !isMediaAttached) {
      sendMessage(messageRef.current.value.trim(), showText);
    } else if (isMediaAttached) {
      let textMessage = hasTextMessage ? messageRef.current.value.trim() : null;
      setIsLoading(true);

      sendMessageWithAttachemnts(previewFiles, textMessage).finally(() => {
        tempFilesArray = [];
        setIsLoading(false);
        setPreviewFiles([]);
      });
    }
    //  messageRef && messageRef.current && messageRef.current.value = "";
  };

  const handleClose = () => {
    setShowGif(false);
  };

  const onSendChatTranscriptClick = () => downloadChatTranscript();

  const sendChatTranscript = (emailId) => {
    setShowSendChatTranscriptForm(false);
    if (!emailId) {
      return;
    }
  };

  // on x (top right) clicked
  const closeConversationClick = () => {
    if (s360ConfigService.config?.sandBox) return;

    flowMemorySingleton.setLastShownMessageIdForAutoAttachment(false);
    // s360ConfigService.resumedWorkitemId = null;
    // s360ConfigService.resumedWorkitemId = null;
    s360ConfigService.config.historyMessages = false;
    localStorage.removeItem("finalvalue");
    sessionStorage?.removeItem("subscribed");
    setShowCloseDialog(true);
    // s360ConfigService.firstMessageDone = null;
    // s360ConfigService.firstButtonDone = null;
    setOpen(false);
    setIsReset(true);

    //s360ConfigService.config.isNewConversation = false;
    s360ConfigService.config.contactId = false;
    // restartConversationOnClose()
    // let sessionId =
    //   props.activeConversation && props.activeConversation.sessionId;
    // if (!sessionId) {
    //   return;
    // }
  };

  // on End Chat inside close screen clicked
  const onEndChat = async () => {
    props.actions.setIsAppOpen(false);
    if (s360ConfigService.config.hideIcon) {
      if (typeof props.actions?.onHideChatWindow === "function") {
        props.actions.onHideChatWindow();
      }
    }

    const isMobile = s360ConfigService.getConfig()?.isMobile;

    // For mobile: wait for terminate API to complete before continuing
    // For non-mobile: call without await (original behavior - runs in background)
    if (isMobile) {
      await restartConversationOnClose();
    } else {
      restartConversationOnClose();
    }

    setShowCloseDialog(false);
    setHideInputForHistory(false);
    flowMemorySingleton.setAgentMessageStarted(true);
    flowMemorySingleton.setCurrentAgentUserId(null);
    setMessages((_) => []);
    s360ConfigService.firstMessageDone = null;
    s360ConfigService.firstButtonDone = null;
    s360ConfigService.activeConversationTicketId = null;
    s360ConfigService.config.newConversationPreventHistory = false;
    if (s360ConfigService.config?.configDetails?.pendoIntegratedChat) {
      // setTimeout(() => {
      //   window.parent.postMessage(
      //     {
      //       pendoEndChat: "true",
      //     },
      //     "*"
      //   );
      // }, 500);
    }

    // Send postMessage only for mobile, and only after terminate API completes
    if (isMobile) {
      try {
        const chatEndedMessage = JSON.stringify({
          type: "CHAT_ENDED",
          source: "react-app-live-chat",
          timestamp: Date.now(),
          sessionId: props?.activeConversation?.sessionId,
        });

        // React Native WebView direct bridge
        // Works on Android (main frame) and iOS (main frame only)
        if (window.ReactNativeWebView?.postMessage) {
          window.ReactNativeWebView.postMessage(chatEndedMessage);
          return;
        }

        // Iframe fallback — required for iOS
        // On iOS, ReactNativeWebView is only injected into the main/top frame.
        // When this widget runs inside an iframe, ReactNativeWebView is undefined.
        // The native app has a message event listener on the parent frame that
        // catches this postMessage and forwards it to ReactNativeWebView.postMessage().
        if (window.parent && window.parent !== window) {
          window.parent.postMessage(chatEndedMessage, "*");
        } else {
          window.postMessage(chatEndedMessage, "*");
        }
      } catch (error) {
        HWLog.error("Failed to send chat ended message:", error);
      }
    }
  };

  const restartNCXConversation = async (data) => {
    s360ConfigService.agentConnected = false;
    setMessages([]);
    setWorkitemIdArrays([]);
    latestWorkitemIdRef.current = null;
    setShowCloseDialog(false);
    flowMemorySingleton.setLastShownMessageIdForAutoAttachment(false);
    flowMemorySingleton.setAgentMessageStarted(true);
    flowMemorySingleton.setCurrentAgentUserId(null);

    preventHistory.current = true;

    setSessionClosedbyAgent(false);
    setClosedBySystemTimeout(false);
    // Preserve formDetails so the next initiateChat call can still derive
    // the primary-identification value and keep isAnonymous correct.
    const previousFormDetails = s360ConfigService.thrioConfig?.formDetails;
    s360ConfigService.thrioConfig = {};
    if (previousFormDetails) {
      s360ConfigService.thrioConfig.formDetails = previousFormDetails;
    }
    s360ConfigService.chatHistory = null;
    s360ConfigService.activeSessions = {};
    s360ConfigService.resumedWorkitemId = null;
    s360ConfigService.config.workitemId = null;
    s360ConfigService.config.anonymousClosed = true; //prevents history from being called
    s360ConfigService.config.isNewConversation = false;
    s360ConfigService.activeConversationTicketId = null;
    if (!terminatedDueToTimeout) {
      await apiService.terminateChat(currentWorkitemId);
    }
    // if (
    //   s360ConfigService.config?.anonymous &&
    //   s360ConfigService.config?.s360UserConfig?.primaryIdentification
    // ) {
    //   localStorage.removeItem("isLoggedIn");
    //   sessionStorage.removeItem("userContext");
    //   removeCookieForContactDetails(s360ConfigService.config.configId);
    // }
    if (
      primaryIdentification === null ||
      primaryIdentification === "null" ||
      !primaryIdentification
    ) {
      s360ConfigService.activeConversation = null;
      localStorage.removeItem("isLoggedIn");
      sessionStorage.removeItem("userContext");
      localStorage.removeItem("FAQ_Article_Clicked");
      removeCookieForContactDetails(s360ConfigService.config.widgetconfigId);
      props.removeAllCookies();
      if (!s360ConfigService.config.anonymous) {
        props.actions.moveToPage("initialForm");
      } else {
        props.actions.moveToPage("landingPage");
      }
      //delete primaryIdentification from context
      //remove login
      //remove cookies
      // Do something with primaryIdentification
    } else {
      setTimeout(() => {
        props.actions.startNewConversation();
      }, 1000);
    }
  };

  const goToLandingFromHistoryConversation = () => {
    // console.log("here1");
    setMessages((_) => []);
    setShowCloseDialog(false);
    s360ConfigService.config.newConversationPreventHistory = false;
    flowMemorySingleton.setLastShownMessageIdForAutoAttachment(false);
    flowMemorySingleton.setAgentMessageStarted(false);
    flowMemorySingleton.setCurrentAgentUserId(null);

    setSessionClosedbyAgent(false);
    setClosedBySystemTimeout(false);
    s360ConfigService.thrioConfig = {};
    s360ConfigService.chatHistory = null;
    s360ConfigService.activeSessions = {};
    s360ConfigService.resumedWorkitemId = null;
    latestWorkitemIdRef.current = null;
    s360ConfigService.config.workitemId = null;
    s360ConfigService.config.anonymousClosed = false; //prevents history from being called
    s360ConfigService.config.isNewConversation = false;
    props.actions?.showLandingScreen();
  };

  const restartConversationOnClose = async (data) => {
    s360ConfigService.agentConnected = false;
    setWorkitemIdArrays([]);
    latestWorkitemIdRef.current = null;
    s360ConfigService.resumedWorkitemId = null;
    if (props.actions?.setActiveConversation) {
      props.actions.setActiveConversation(null);
    }
    preventHistory.current = true;
    //use primaryIdentification from context
    if (
      primaryIdentification === null ||
      primaryIdentification === "null" ||
      !primaryIdentification
    ) {
      s360ConfigService.activeConversation = null;
      localStorage.removeItem("isLoggedIn");
      sessionStorage.removeItem("userContext");
      localStorage.removeItem("FAQ_Article_Clicked");
      removeCookieForContactDetails(s360ConfigService.config.widgetconfigId);
      props.removeAllCookies();
      if (!s360ConfigService.config.anonymous) {
        props.actions.moveToPage("initialForm");
      } else {
        // props.actions.moveToPage("landingPage");
      }

      //delete primaryIdentification from context
      //remove login
      //remove cookies
      // Do something with primaryIdentification
    }
    setTimeout(() => {
      s360ConfigService.config.isNewConversation = false;
    }, 500);

    s360ConfigService.config.historyMessages = false;
    s360ConfigService.config.contactId = false;
    s360ConfigService.firstMessageDone = null;
    s360ConfigService.firstButtonDone = null;
    if (s360ConfigService.thrioConfig) {
      await apiService.terminateChat(currentWorkitemId);
      // Preserve formDetails so restart chat can still derive isAnonymous correctly
      const previousFormDetails = s360ConfigService.thrioConfig?.formDetails;
      s360ConfigService.thrioConfig = {};
      if (previousFormDetails) {
        s360ConfigService.thrioConfig.formDetails = previousFormDetails;
      }
      s360ConfigService.chatHistory = null;
      s360ConfigService.activeSessions = {};
      s360ConfigService.config.workitemId = null;

      s360ConfigService.config.anonymousClosed = true;

      setDownloadHistoryStep({
        step: 0,
        historyWorkItemId: "",
        activeMessages: [],
        ticketId: "",
      });

      // if (
      //   s360ConfigService?.config?.configDetails?.showForm &&
      //   !s360ConfigService?.config?.anonymous
      // ) {
      //   props.actions.moveToPage(PageName.initialForm);
      // } else if (
      //   !s360ConfigService?.config?.configDetails?.showForm ||
      //   s360ConfigService?.config?.anonymous
      // ) {
      //   props.actions.moveToPage(PageName.landingPage);
      //   props.actions.startNewConversation({ closed: true });
      // }
    }

    props.actions.onHideChatWindow();
    if (s360ConfigService.config?.configDetails?.pendoIntegratedChat) {
      window.parent.postMessage(
        {
          pendoEndChat: "true",
        },
        "*",
      );

      // window.parent.postMessage(
      //   {
      //     minimize: "true",
      //   },
      //   "*"
      // );
    } else {
      window.parent.postMessage(
        {
          minimize: "true",
        },
        "*",
      );
    }
  };
  const handleSnackbarClose = () => setShowSnackBar(false);

  const showSnackBarWithMessage = (message, autoCloseDuration = 2000) => {
    setShowSnackBar(true);
    setSnackBarMesssage(message);

    // Auto-close the snackbar after the specified duration
    if (autoCloseDuration > 0) {
      setTimeout(() => {
        setShowSnackBar(false);
      }, autoCloseDuration);
    }
  };

  const isActiveConversation = () => {
    return s360ConfigService.config.preview
      ? true
      : props?.activeConversation?.isActive;
    // let isClosed =
    //   props?.activeConversation?.active === false || isConversationClosed;
    // return !isClosed;
  };

  const createInfoMessage = (id, message, interval, loop, intervalToClear) => {
    //TIMERTODO create and push message
    if (agentNotificationMessageIdsCopy.includes(id)) {
      let messageToShow = message;
      let messageTime = new Date();
      let chatInfoMessage = {
        message: { text: messageToShow, sentTimestamp: messageTime.getTime() },
        id: `agent-info-message${id}+${messageTime.getTime()}`,
        type: MessageType.info,
        timestamp: messageTime.getTime(),
        convoType: "TEXT",
        syntheticMessage: true,
      };
      addMessagesToList([chatInfoMessage]);
      if (!loop) {
        const index = agentNotificationMessageIdsCopy.indexOf(id);
        if (index > -1) {
          // only splice array when item is found
          agentNotificationMessageIdsCopy.splice(index, 1); // 2nd parameter means remove one item only
        }
        clearInterval(intervalToClear);
      } else if (loop && loopMessagerecived !== id) {
        const index = agentNotificationMessageIdsCopy.indexOf(id);
        if (index > -1) {
          // only splice array when item is found
          agentNotificationMessageIdsCopy.splice(index, 1); // 2nd parameter means remove one item only
        }
        clearInterval(intervalToClear);
      }
    }
    // clear id value in array id loop false
  };

  const setLoopMessageInterval = (id, message, interval, loop) => {
    agentNotificationMessageIds[agentNotificationMessageIds.indexOf(id)] =
      setInterval(() => {
        createInfoMessage(id, message, interval, loop);
      }, interval * 1000);
  };

  const setNormalMessageInterval = (id, message, interval, loop) => {
    let tempinterval = setInterval(() => {
      createInfoMessage(id, message, interval, loop, tempinterval);
    }, interval * 1000);
  };

  const createDynamicIntervals = (data) => {
    const { id, message, interval, loop } = data;
    if (loop && !loopMessagerecived) {
      setLoopMessageInterval(id, message, interval, loop);
      loopMessagerecived = id;
    } else {
      setNormalMessageInterval(id, message, interval, loop);
    }
  };

  const handleConnectionChange = useCallback(async (workId) => {
    const condition = navigator.onLine ? "online" : "offline";

    if (condition === "offline") {
      return;
      // setShowLoaderBotPopup(true);
      // setShowErrorMsg("Seems you lost your internet connection...");
    } else if (condition === "online") {
      if (!workId) {
        internetListenerAdded = true;
        return;
      }
      let chatStatus = await apiService.getChatStaleStatus(workId);
      if (
        chatStatus?.data?.state === "terminated" ||
        chatStatus?.data?.state === "dispositioned"
      ) {
        // Dispatch a custom event with workitemId to stop keepAlive
        const stopKeepAliveEvent = new CustomEvent(
          `stopKeepAlive_${currentWorkitemId}`,
          {
            detail: { currentWorkitemId },
          },
        );
        // s360ConfigService.config.forceAllowWebsocket = true;
        setTerminatedDueToTimeout(true);
        window.dispatchEvent(stopKeepAliveEvent);

        onWorkitemTerminated();
      }
    }

    internetListenerAdded = true;
  }, []);

  const isOnSameDay = (date, anotherDate) => {
    return (
      dayjs.unix(date).format("YY MMM DD") ===
      dayjs.unix(anotherDate).format("YY MMM DD")
    );
  };

  const disablePreviousButtonsOnHistory = (msgs) => {
    const newMessages = msgs;

    let enabledLastBotMessage = false;
    if (newMessages.length > 0) {
      if (newMessages.length === 1) {
        newMessages.forEach((m) => (m.disabled = false));
      } else {
        for (let i = newMessages.length - 1; i >= 0; i--) {
          if (enabledLastBotMessage) {
            newMessages[i].disabled = true;
          } else {
            if (newMessages[i].creator === "BOT") {
              newMessages[i].disabled = false;
              enabledLastBotMessage = true;
            }
          }
        }
      }
    }

    setMessages((_) => [...newMessages]);
  };

  const parseMessageHistoryResponse = (message) => {
    setShowLoaderBotPopup(false);

    const isAgentConnected = sessionStorage.getItem("agentConnected");
    if (isAgentConnected) {
      disableOnAgentConnections();
    }
    localStorage.removeItem("autoOpenChat");
    HWLog.info("HISTORY_RESPONSE LIST MESSAGES", message);
    if (!message.listHistoryInfo || message.listHistoryInfo.length === 0) {
      setIsFetchingMessages(false);
      HWLog.info("EMPTY HiSTORY LIST");
      return;
    }
    let messagesToAdd = message.listHistoryInfo || [];
    messagesToAdd = messagesToAdd.map((i) => {
      i.id = i.id + "";
      let check = checkEmoji(i.message.text);
      if (i.convoType === "TEXT" && check) {
        i.convoType = "EMOJI";
      }
      return i;
    });

    messagesToAdd.map((messageToAdd) => {
      if (messageToAdd?.message?.chatResponse?.entries) {
        messageToAdd?.message?.chatResponse?.entries.map((entry, index) => {
          if (entry?.uiCommand === "A99") {
            messageToAdd?.message?.chatResponse?.entries.splice(index, 1);
          }
          return messageToAdd;
        });
      }
      return messagesToAdd;
    });

    addMessagesToList(messagesToAdd.reverse());
    disablePreviousButtonsOnHistory(messagesToAdd);
  };

  const parseSessionCloseResponse = (message) => {
    let sessionId = message.sessionId || "";
    let activeSessionInfo = props.activeConversation || {};

    if (activeSessionInfo.sessionId === sessionId) {
      props.actions.markActiveConversationAsClosed();
      let sessionCloseMessage = getSessionCloseMessage();
      if (s360ConfigService?.config?.configDetails?.startNewSession) {
        addMessagesToList([sessionCloseMessage]);
      }
    } else {
      showSnackBarWithMessage("Could not close coversation, please try again.");
    }
  };

  // Add Agent Transfer Ino Message.
  const parseChatStatusResponse = (message) => {
    agentNotificationMessageIds = [];
    agentNotificationMessageIdsCopy = [];
    disableOnAgentConnections();
    let sessionId = message.sessionId || "";
    let activeSessionInfo = props.activeConversation || {};
    if (activeSessionInfo.sessionId !== sessionId) {
      HWLog.warn("Invalid Chat Satus Session Id: ");
      return;
    }

    let firstName = (message.agentInfo && message.agentInfo.firstName) || "";
    let lastName = (message.agentInfo && message.agentInfo.lastName) || "";
    let showAgentInfo =
      props.config &&
      props.config.configDetails &&
      props.config.configDetails.showAgentInfo;
    if (!firstName.trim() || !lastName.trim()) {
      return;
    }
    let agentName = (firstName + " " + lastName).trim();
    sessionStorage.setItem("agentName", agentName);
    let messageToShow = "You are transferred to agent " + agentName;
    let messageTime = new Date();
    let chatInfoMessage = {
      message: { text: messageToShow, sentTimestamp: messageTime.getTime() },
      id: "agent-info-message",
      type: MessageType.info,
      timestamp: messageTime.getTime(),
      convoType: "TEXT",
      syntheticMessage: true,
    };

    addMessagesToList([chatInfoMessage]);
    let headerVal = document.getElementsByClassName(
      "s360-conversation-header-details-title",
    );
    let headerValfs = document.getElementsByClassName(
      "s360-conversation-header-details-title-fs",
    );

    for (let i = 0; i < headerVal.length; i++) {
      if (headerVal[i]) headerVal[i].innerHTML = agentName;
    }
    if (headerValfs) {
      for (let i = 0; i < headerValfs.length; i++) {
        if (headerValfs[i]) headerValfs[i].innerHTML = agentName;
      }
    }
    // let agentDisplayInitials =
    //   message.agentInfo &&
    //     message.agentInfo.firstName &&
    //     message.agentInfo.lastName
    //     ? message.agentInfo.firstName.charAt(0) +
    //     "" +
    //     message.agentInfo.lastName.charAt(0)
    //     : "B";
    const agentImage = DummyAgentImage;
    const brandIcon = s360ConfigService?.config?.configDetails?.brandIcon;
    const agentProfilePic = message?.agentInfo?.userProfilePic;
    if (showAgentInfo) {
      document.getElementById("s360-agent-image").src =
        agentProfilePic || brandIcon || agentImage;
    }
  };

  const parseBotReplyResponse = (message) => {
    ackBotReply(message);

    let messageTime = new Date();
    let sessionId = message.sessionId || "";
    let activeSessionInfo = props.activeConversation || {};
    if (activeSessionInfo.sessionId !== sessionId) {
      HWLog.info("Invalid Session Id: For BOT REPLY: ", message || {});
      return;
    }

    if (!message.id) {
      message.id = uuid();
    }
    message.id = message.id + "";
    message.message.sentTimestamp = messageTime.getTime();

    addMessagesToList([message]);
    if (s360ConfigService.config.notification.isEnabled && playSound) {
      audio?.play();
    }
    if (props.config.configDetails?.browserNotification) {
      if (message.message?.chatResponse?.entries?.length) {
        message.message.chatResponse.entries.forEach((entry) =>
          sendNotification(entry.text),
        );
      } else if (message.message?.text) {
        sendNotification(message.message?.text);
      }
    }
  };

  const ackBotReply = (payload) => {
    const result = { ...payload };
    result.command = "ACK_BOT_REPLY";
  };

  const parseAgentReplyResponse = (message) => {
    if (message.command === "AGENT_REPLY") {
      ackAgentClientMsg(message);
    }
    let sessionId = message.sessionId || "";
    let activeSessionInfo = props.activeConversation || {};
    if (
      activeSessionInfo.sessionId !== sessionId &&
      !s360ConfigService.thrioConfig
    ) {
      HWLog.info("Invalid Session Id: For AGENT REPLY: ", message || {});
      return;
    }
    if (!message.id) {
      message.id = uuid();
    }
    // message.id = message.message.sentTimestamp;
    // message.creator = "AGENT";
    // let newMessageToSend = {
    //   message: {
    //     text: message.message.text,
    //     sentTimestamp: message.message.sentTimestamp,
    //     id: message.id,
    //   },
    //   id: message.id,
    //   type: MessageType.received,
    //   timestamp: message.message.sentTimestamp,
    //   convoType: message.convoType,
    //   creator: "AGENT",
    //   syntheticMessage: true,
    // };

    addMessagesToList([message]);
    if (s360ConfigService.config.notification.isEnabled && playSound) {
      audio?.play();
    }
    if (props.config.configDetails?.browserNotification) {
      sendNotification(message.message.text);
    }
  };

  const ackAgentClientMsg = (payload) => {
    const result = { ...payload };
    result.command = "ACK_AGENT_REPLY";

    result["sentTimestamp"] = result.originalTimeStamp;
  };

  const parseTypingIndicatorResponse = (message) => {
    let isTyping = message.typing || false;
    let sessionId = message.sessionId || "";
    let activeSessionInfo = props.activeConversation || {};
    if (activeSessionInfo.sessionId !== sessionId) {
      HWLog.info("Invalid Session Id: For Typing Indicator: ", message || {});
      return;
    }
    setIsTyping(isTyping);
  };

  const parseChatTranscriptResponse = () =>
    props.actions.showPopUpMessage(
      "The transcript is sent to your preferred Email ID",
    );
  const [loading, setLoading] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const lastMessageRef = useRef(null);

  // useEffect(() => {
  //   const observer = new IntersectionObserver(
  //     (entries) => {
  //       if (entries[0].isIntersecting && !loading) {
  //         // setPage((prev) => prev + 1);
  //
  //       }
  //     },
  //     { threshold: 1.0 } // Trigger when the last message is fully visible
  //   );

  //   if (lastMessageRef.current) {
  //     observer.observe(lastMessageRef.current);
  //   }

  //   return () => {
  //     if (lastMessageRef.current) {
  //       observer.unobserve(lastMessageRef.current);
  //     }
  //   };
  // }, [loading]);
  // useEffect(() => {
  //   if (props.conversation?.ticketId) {
  //     persistedTicketIdRef.current = props.conversation.ticketId;
  //     console.log("Updated persisted ticketId:", persistedTicketIdRef.current);
  //   }
  // }, [props.conversation?.ticketId]);

  function fetchAndPopulateHistory(
    ticketId,
    workitemId = null,
    continueToDownload = () => {},
    isOnlineTemp,
    options = {},
  ) {
    console.log("fetchAndPopulateHistory", ticketId, workitemId);
    const { silent = false, limit = 100, fetchOptions = {} } = options || {};
    const fetchMessages = async () => {
      // if (!isOnline) {
      //   console.log("Browser is offline, skipping history fetch");
      //   setShowLoaderBotPopup(false);
      //   setLoading(false);
      //   // Optionally show offline message
      //   if (networkQuality === "offline") {
      //     setShowErrorMsg(
      //       "You are currently offline. Please check your connection."
      //     );
      //   }
      //   return;
      // }
      s360ConfigService.config.historyMessages = true;
      console.log("settingMessages empty", ticketId, workitemId);
      if (!silent) {
        setMessages((_) => []);
      }
      // if (!isOnline) {
      //   if (props.isAppOpen) {
      //     setMessages((_) => [...props.backupMessages]);
      //   }
      // }
      if (!silent) {
        setLoading(true);
      }
      const requestId = historyRequestIdRef.current + 1;
      historyRequestIdRef.current = requestId;
      const isLatestRequest = () => historyRequestIdRef.current === requestId;
      const historyWorkitemId =
        workitemId ||
        currentWorkitemId ||
        s360ConfigService.resumedWorkitemId ||
        null;
      // if (!historyWorkitemId) {
      //   if (isLatestRequest()) {
      //     setShowLoaderBotPopup(false);
      //     setLoading(false);
      //     continueToDownload();
      //   }
      //   console.log("bleh bleh?");
      //   return;
      // }

      let chatStatus;
      if (isOnlineTemp) {
        try {
          chatStatus = await apiService.getChatStaleStatus(historyWorkitemId);
          // console.log("settingMessages chatStatus", chatStatus);
        } catch (error) {
          if (isLatestRequest()) {
            console.log("Failed to fetch chat status", error);
            if (!silent) {
              setShowLoaderBotPopup(false);
              setLoading(false);
            }
          }
          console.error("Failed to fetch chat status", error);
          return;
        }

        // if (!isLatestRequest()) {
        //   return;
        // }

        if (
          chatStatus?.data?.state === "terminated" ||
          chatStatus?.data?.state === "dispositioned"
        ) {
          const stopKeepAliveEvent = new CustomEvent(
            `stopKeepAlive_${currentWorkitemId}`,
            {
              detail: { currentWorkitemId },
            },
          );
          // s360ConfigService.config.forceAllowWebsocket = true;
          setTerminatedDueToTimeout(true);
          window.dispatchEvent(stopKeepAliveEvent);

          onWorkitemTerminated();

          setHideInputForHistory(true);
        } else {
          setHideInputForHistory(false);
        }
      }
      try {
        // console.log("settingMessages chatHistory", ticketId);
        if (isOnlineTemp) {
          const historyRequestOptions = {
            limit,
            ...fetchOptions
          };

          let chatHistory = await apiService.getTicketHistory(
            ticketId,
            historyRequestOptions,
          );

          chatHistory =
            typeof chatHistory.data === "string"
              ? []
              : chatHistory.data.reverse(); // reverse the chat history
          chatHistory = filterByLatestWorkitemId(
            chatHistory,
            historyWorkitemId,
          );
          if (!isLatestRequest()) {
            console.log("Not the latest request");
            return;
          }

          // Process chat history
          chatHistory.forEach((msg) => {
            if (!msg.message || msg?.userType === "AGENT") {
              return;
            }

            try {
              if (isValidJSON(msg?.message)) {
                const parsedMessage = JSON.parse(msg.message);

                if (
                  typeof parsedMessage !== "string" &&
                  parsedMessage?.isAiEnabled
                ) {
                  setShowInputBox(true);
                  setIsAiBot(true);
                }
              }
            } catch (error) {
              console.error("Error parsing message:", msg?.message, error);
            }
          });

          // if (!isLatestRequest()) {
          //   return;
          // }
          // console.log(
          //   "settingMessages adding messages from history ",
          //   chatHistory
          // );
          addMessagesToList(chatHistory, { replace: silent, isHistory: true });
          if (silent) {
            console.log("[FocusRefresh] Silent history applied", {
              workitemId: historyWorkitemId,
              messageCount: chatHistory.length,
            });
          }
          if (!silent) {
            setShowLoaderBotPopup(false);
          }
          continueToDownload();
          if (!silent) {
            setLoading(false);
          }
        }
      } catch (e) {
        if (isLatestRequest()) {
          // console.log("settingMessages Failed to fetch chat history", e);
          if (!silent) {
            setShowLoaderBotPopup(false);
            setLoading(false); // Ensure loading state is cleared in case of error
          }
        }
      }
    };

    fetchMessages();
  }

  useEffect(() => {
    silentHistoryReloadRef.current = async () => {
      if (
        !props.isAppOpen ||
        s360ConfigService.config?.sandBox ||
        !currentWorkitemId ||
        !isOnline
      ) {
        console.log("[FocusRefresh] Skipped - widget not ready", {
          isAppOpen: props.isAppOpen,
          sandBox: s360ConfigService.config?.sandBox,
          currentWorkitemId,
          isOnline,
        });
        return;
      }

      if (!allowSilentRefreshRef.current) {
        console.log(
          "[FocusRefresh] Skipped - silent refresh disabled after termination",
        );
        return;
      }

      const now = Date.now();
      if (focusReloadInFlightRef.current) {
        console.log("[FocusRefresh] Skipped - refresh already in flight");
        return;
      }

      if (now - focusReloadTimestampRef.current < 4000) {
        console.log("[FocusRefresh] Skipped - throttle window active");
        return;
      }

      focusReloadTimestampRef.current = now;
      focusReloadInFlightRef.current = true;
      console.log("[FocusRefresh] Triggered silent history refresh", {
        workitemId: currentWorkitemId,
      });

      try {
        let ticketId = props.conversation?.ticketId || null;

        if (!ticketId) {
          const data = await apiService.getCurrentTicketId(currentWorkitemId);
          if (
            data?.data?.length > 0 &&
            data.data[data.data.length - 1]?.parentTicketId
          ) {
            ticketId = data.data[data.data.length - 1]?.parentTicketId;
          }
        }

        if (ticketId) {
          console.log("[FocusRefresh] Starting silent history fetch", {
            workitemId: currentWorkitemId,
            ticketId,
          });
          await fetchAndPopulateHistory(
            ticketId,
            currentWorkitemId,
            () => {},
            isOnline,
            {
              silent: true,
              fetchOptions: {
                autoRefresh: true,
                workitemId: currentWorkitemId,
              },
            },
          );
          console.log("[FocusRefresh] Silent history fetch finished", {
            workitemId: currentWorkitemId,
          });
        } else {
          console.log("[FocusRefresh] Skipped silent refresh - no ticketId", {
            workitemId: currentWorkitemId,
          });
        }
      } catch (error) {
        console.error("[FocusRefresh] Silent history refresh failed", error);
      } finally {
        focusReloadInFlightRef.current = false;
        console.log("[FocusRefresh] Silent history refresh settled", {
          workitemId: currentWorkitemId,
        });
      }
    };

    return () => {
      if (silentHistoryReloadRef.current) {
        silentHistoryReloadRef.current = null;
      }
    };
  }, [
    props.isAppOpen,
    props.conversation?.ticketId,
    currentWorkitemId,
    isOnline,
    fetchAndPopulateHistory,
  ]);

  const showPDFBrandIcon = () => {
    if (s360ConfigService?.config?.configDetails?.brandIcon) {
      return `<img
          style="height: 20px; width: 20px; margin-left: 4px"
          src="${s360ConfigService?.config?.configDetails?.brandIcon}"
          alt="brand icon"
        />`;
    }
    return "";
  };

  const generateAndDownloadPDF = (ticketId, fromLandingPage, pdfReady) => {
    try {
      const generatePDF = () => {
        const printHtml = targetRef.current;
        if (fromLandingPage) {
          pdfReady();
        }
        if (printHtml) {
          setTimeout(() => {
            // Get all stylesheets and rules
            const styles = Array.from(document.styleSheets)
              .map((styleSheet) => {
                try {
                  return Array.from(styleSheet.cssRules)
                    .map((rule) => rule.cssText)
                    .join("");
                } catch (e) {
                  console.error(e);
                  return "";
                }
              })
              .join("");

            // Sanitize the content
            const sanitizedHTML = DOMPurify.sanitize(printHtml.innerHTML, {
              ADD_ATTR: ["target", "rel"],
              FORCE_BODY: true,
            });

            // Create a hidden iframe
            const iframe = document.createElement("iframe");
            iframe.style.position = "absolute";
            iframe.style.top = "-10000px";
            iframe.style.left = "-10000px";
            iframe.sandbox =
              "allow-forms allow-popups allow-same-origin allow-scripts allow-top-navigation allow-modals allow-popups-to-escape-sandbox allow-storage-access-by-user-activation";
            document.body.appendChild(iframe);

            // Write content into the iframe
            const iframeDoc = iframe.contentWindow || iframe.contentDocument;
            const iframeContent = iframeDoc.document || iframeDoc;

            iframeContent.open();
            iframeContent.write(`
              <html>
                <head>
                  <title>&nbsp;</title>
                  <style>
                    ${styles}
                    @media print {
                      * {
                        -webkit-print-color-adjust: exact;
                        print-color-adjust: exact;
                      }
                      body {
                        background-color: white;
                        margin: 0;
                        padding: 0;
                        display: block;
                        text-align: justify;
                        font-family: system-ui;
                        color: #000000;
                        
                        zoom: 0.7;
                      }
                      @page {
                        size: A4;
                        margin: 10mm;
                      }
                      html, body {
                        margin: 0;
                        padding: 0;
                      }
                      .no-page-break {
                        page-break-inside: avoid;
                      }
                      div, section, header, footer {
                        page-break-inside: avoid;
                      }
                      .page-break {
                        page-break-after: always;
                      }
                      
                    }
                  </style>
                </head>
                <body>
                  <div style="
                      width: 100%;
                      margin-top: 24px;
                      margin-bottom: 48px;
                      color: #000000;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      flex-direction: column;
                  ">
                      <div style="
                          width: 100%;
                          display: flex;
                          align-items: center;
                          justify-content: space-between;
                          flex-direction: row;
                      ">
                          <span style="font-size: 20px; font-weight: 800;">Transcript</span>
                          <div style="font-weight: 800; font-size: 20px; margin-bottom: 4px; display: flex; align-items: center; gap: 4px">
                              ${showPDFBrandIcon()} 
                              ${
                                s360ConfigService?.config?.configDetails
                                  ?.brandName
                              }
                          </div>
                      </div>
                      <div style="
                          width: 100%;
                          display: flex;
                          align-items: center;
                          justify-content: space-between;
                          flex-direction: row;
                      ">
                          <span style="font-size: 12px; color: #545454;">
                              ${
                                ticketId && ticketId.trim() !== ""
                                  ? "Ticket Id: " + ticketId
                                  : ""
                              }
                          </span>
                      </div>
                  </div>
                  ${sanitizedHTML}
                </body>
              </html>
            `);
            iframeContent.close();

            // Print and clean up the iframe
            iframe.onload = () => {
              iframe.contentWindow.focus(); // Ensure iframe has focus
              iframe.contentWindow.print();
              setTimeout(() => {
                document.body.removeChild(iframe); // Remove iframe after printing
              }, 100);
            };
            if (!fromLandingPage) {
              pdfReady();
            }
          }, 2000);
        }
      };

      generatePDF();
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    // if (!navigator.onLine) {
    //   return;
    // }
    const runStep = async () => {
      switch (downloadHistoryStep.step) {
        case 1:
          setMessages([]);
          setDownloadHistoryStep((prev) => ({ ...prev, step: 2 }));
          break;

        case 2:
          await fetchAndPopulateHistory(
            downloadHistoryStep.ticketId,
            downloadHistoryStep.historyWorkItemId,
            () => {
              setDownloadHistoryStep((prev) => ({ ...prev, step: 3 }));
            },
            isOnline,
          );
          break;

        case 3:
          showSnackBarWithMessage("Download will start soon.");
          await new Promise((resolve) => setTimeout(resolve, 100));
          generateAndDownloadPDF(
            downloadHistoryStep.ticketId,
            downloadHistoryStep?.fromLandingPage,
            () => {
              setDownloadHistoryStep((prev) => ({ ...prev, step: 4 }));
            },
          );
          break;

        case 4:
          setMessages([...downloadHistoryStep.activeMessages]);
          setDownloadHistoryStep((prev) => ({ ...prev, step: 5 }));
          setDownloadInProgress(false);
          if (props?.downloadHistoryForWorkItemId) {
            dispatchEvent(new CustomEvent("transcriptDownloadDone"));
          }
          break;

        default:
          break;
      }
    };

    runStep();
  }, [downloadHistoryStep.step]);

  function downloadHistory(ticketId, workitemId) {
    const activeMessages = messages;
    setDownloadInProgress(workitemId);
    setDownloadHistoryStep((_) => ({
      step: 1,
      historyWorkItemId: workitemId,
      ticketId: ticketId,
      activeMessages: activeMessages,
      fromLandingPage: false,
    }));
  }

  useEffect(() => {
    if (props?.downloadHistoryForWorkItemId) {
      const activeMessages = messages;
      setDownloadInProgress(props.downloadHistoryForWorkItemId.ticketId);
      setDownloadHistoryStep((_) => ({
        step: 1,
        historyWorkItemId: props.downloadHistoryForWorkItemId.workItemId,
        ticketId: props.downloadHistoryForWorkItemId.ticketId,
        activeMessages: activeMessages,
        fromLandingPage: true,
      }));
    }
  }, []);

  useEffect(() => {
    if (downloadChatTranscriptStep === 1 && currentWorkitemId) {
      let foundTicketId = null;
      apiService
        .getCurrentTicketId(currentWorkitemId)
        .then((data) => {
          if (
            data?.data?.length > 0 &&
            data?.data[data?.data?.length - 1]?.parentTicketId
          ) {
            foundTicketId = data?.data[data?.data?.length - 1]?.parentTicketId;
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          showSnackBarWithMessage("Download will start soon.");
          setTimeout(() => {
            generateAndDownloadPDF(foundTicketId, false, () => {
              setDownloadChatTranscriptStep(2);
            });
          }, 100);
        });
    }
    if (downloadChatTranscriptStep === 2) {
      setDownloadInProgress(false);
      if (
        s360ConfigService.activeConversation &&
        flowMemorySingleton.getAgentMessageStarted()
      ) {
        setHideInputForHistory(false);
      }
      setDownloadChatTranscriptStep(3);
    }
  }, [downloadChatTranscriptStep]);

  function downloadChatTranscript() {
    setDownloadInProgress(true);
    setDownloadChatTranscriptStep(1);
  }

  useEffect(() => {
    if (
      !props.isAppOpen ||
      s360ConfigService.config.sandBox ||
      preventHistory.current ||
      !currentWorkitemId
    ) {
      return;
    }

    // Coalesce duplicate triggers for the same effective inputs
    const fetchKey = [
      String(!!props.isAppOpen),
      props.conversation?.ticketId || "",
      props.conversation?.workitemId || "",
      currentWorkitemId || "",
    ].join("|");

    // if (lastHistoryFetchKeyRef.current === fetchKey) {
    //   return;
    // }
    lastHistoryFetchKeyRef.current = fetchKey;

    // const globalRegistry = (s360ConfigService.__historyFetchKeys ||= new Set());
    // if (globalRegistry.has(fetchKey)) {
    //   return;
    // }
    // if (!navigator.onLine) {
    //   setMessages((_) => [...props.backupMessages]);
    //   return;
    // }
    if (!isOnline) {
      if (messages.length === 0) setMessages((_) => [...props.backupMessages]);
      return;
    }
    if (props.conversation?.ticketId) {
      fetchAndPopulateHistory(
        props.conversation.ticketId,
        currentWorkitemId,
        () => {},
        isOnline,
      );
      return;
    }

    let foundTicketId = null;
    let cancelled = false;

    apiService
      .getCurrentTicketId(currentWorkitemId)
      .then((data) => {
        if (
          data?.data?.length > 0 &&
          data?.data[data?.data?.length - 1]?.parentTicketId
        ) {
          foundTicketId = data?.data[data?.data?.length - 1]?.parentTicketId;
        }
      })
      .catch((err) => {
        // console.log("rreaching here err");

        console.error(err);
      })
      .finally(() => {
        if (
          !cancelled &&
          foundTicketId &&
          !props?.downloadHistoryForWorkItemId
        ) {
          fetchAndPopulateHistory(
            foundTicketId,
            currentWorkitemId,
            () => {},
            isOnline,
          );
        } else if (!cancelled) {
        }
      });

    return () => {
      cancelled = true;
    };
  }, [
    props.isAppOpen,
    props.conversation?.ticketId,
    props.conversation?.workitemId,
    currentWorkitemId,
  ]);

  // Function to update last non-user message status to READ after history fetch
  const updateLastNonUserMessageToRead = useCallback(
    (historyMessages) => {
      if (!historyMessages || historyMessages.length === 0) {
        return;
      }

      // Find the last non-user message (from AGENT, BOT, or SYSTEM)
      let lastNonUserMessage = null;
      for (let i = historyMessages.length - 1; i >= 0; i--) {
        const message = historyMessages[i];
        if (
          message?.userType &&
          message.userType !== "USER" &&
          message.userType !== "CUSTOMER"
        ) {
          lastNonUserMessage = message;
          break;
        }
        // Also check creator field as fallback
        if (
          message?.creator &&
          message.creator !== "USER" &&
          message.creator !== "CUSTOMER"
        ) {
          lastNonUserMessage = message;
          break;
        }
      }

      if (lastNonUserMessage && lastNonUserMessage.id) {
        // Check if message status is not READ (could be delivered, sent, or undefined)
        const messageStatus = lastNonUserMessage.messageStatus;
        const isAlreadyRead =
          messageStatus === messageStatuses.READ ||
          (Array.isArray(messageStatus) &&
            messageStatus.includes(messageStatuses.READ));

        if (!isAlreadyRead) {
          const workitemId =
            currentWorkitemId ||
            s360ConfigService.config?.workitemId ||
            s360ConfigService.resumedWorkitemId;

          if (workitemId) {
            console.log(
              `Updating last non-user message ${lastNonUserMessage.id} to READ status after history fetch`,
            );

            // Update message status to READ
            apiService
              .updateMessageStatus(workitemId, lastNonUserMessage.id, [
                messageStatuses.READ,
              ])
              .then(() => {
                console.log(
                  `Last non-user message ${lastNonUserMessage.id} marked as read after history fetch`,
                );
              })
              .catch((error) => {
                console.error(
                  `Failed to update last non-user message status to read for ${lastNonUserMessage.id}:`,
                  error,
                );
              });
          }
        }
      }
    },
    [currentWorkitemId],
  );

  const addMessagesToList = (incomingMessages, options = {}) => {
    const { replace = false, isHistory = false } = options;
    if (!incomingMessages || incomingMessages.length === 0) {
      return;
    }

    const agentMessageIdsNeedingStatusUpdate = [];

    const normalizeStatuses = (status) => {
      const toStrings = (value) => {
        if (!value) {
          return [];
        }
        if (typeof value === "string") {
          return value
            .split(",")
            .map((part) => part.trim())
            .filter(Boolean)
            .map((part) => part.toUpperCase());
        }
        if (typeof value === "object") {
          const statusValue = value.status || value.state || value.value;
          if (!statusValue) {
            return [];
          }
          return toStrings(statusValue);
        }
        return [String(value).toUpperCase()];
      };

      if (!status) {
        return [];
      }
      if (Array.isArray(status)) {
        return status.flatMap((entry) => toStrings(entry));
      }
      return toStrings(status);
    };

    const shouldPromoteAgentHistoryMessage = (message) => {
      if (!isHistory || !message || message.userType !== "AGENT") {
        return false;
      }

      const normalizedStatuses = normalizeStatuses(message.messageStatus);
      const hasRead = normalizedStatuses.includes(messageStatuses.READ);

      if (hasRead) {
        return false;
      }

      if (normalizedStatuses.length === 0) {
        return true;
      }

      const allowed = new Set(["SENT", messageStatuses.DELIVERED]);
      return normalizedStatuses.every((state) => allowed.has(state));
    };

    const processedMessagesToAdd = isHistory
      ? (() => {
          // First pass: find indices of agent messages needing promotion
          const promotionCandidateIndices = [];
          incomingMessages.forEach((message, index) => {
            if (shouldPromoteAgentHistoryMessage(message)) {
              promotionCandidateIndices.push(index);
            }
          });

          // Only promote the LAST 10 agent messages
          const last10Set = new Set(promotionCandidateIndices.slice(-10));

          console.log("[HistoryStatus] Agent messages needing promotion", {
            total: promotionCandidateIndices.length,
            promotingLast10: last10Set.size,
          });

          // Second pass: promote only the selected messages
          return incomingMessages.map((message, index) => {
            if (!last10Set.has(index)) {
              return message;
            }

            const messageId =
              message?.id ??
              message?.messageId ??
              message?.clientMessageId ??
              message?.message?.id ??
              message?.message?.messageId ??
              message?.message?.clientMessageId ??
              message?.message?.message?.id ??
              message?.message?.message?.messageId ??
              message?.message?.message?.clientMessageId ??
              message?.message?.message?.message?.id ??
              message?.message?.message?.message?.messageId;

            if (messageId) {
              agentMessageIdsNeedingStatusUpdate.push(messageId);
            }

            return {
              ...message,
              messageStatus: [messageStatuses.DELIVERED, messageStatuses.READ],
            };
          });
        })()
      : incomingMessages;

    let messageToCheckForAi = null;
    if (processedMessagesToAdd[0]?.userType !== "AGENT") {
      try {
        messageToCheckForAi = JSON.parse(processedMessagesToAdd[0]?.message);
      } catch (error) {
        messageToCheckForAi = false;
      }
    }

    if (
      typeof messageToCheckForAi !== "string" &&
      messageToCheckForAi?.isAiEnabled
    ) {
      setShowInputBox(true);
      setIsAiBot(true);
    }

    setMessages((prev) => {
      const baseMessages = replace && !isHistory ? [] : prev;
      const haveOverlappingIds = (() => {
        const baseIds = new Set();
        baseMessages.forEach((msg) => {
          const id = deriveMessageIdentifier(msg);
          if (id !== null && id !== undefined) {
            baseIds.add(String(id));
          }
        });

        let overlapFound = false;
        const incomingIds = new Set();
        processedMessagesToAdd.forEach((msg) => {
          const id = deriveMessageIdentifier(msg);
          if (id === null || id === undefined) {
            return;
          }
          const key = String(id);
          if (incomingIds.has(key) || baseIds.has(key)) {
            overlapFound = true;
          }
          incomingIds.add(key);
        });
        return overlapFound;
      })();

      const shouldMerge = replace || isHistory || haveOverlappingIds;

      if (!shouldMerge) {
        return [...baseMessages, ...processedMessagesToAdd];
      }

      const merged = mergeMessagesPreservingOrder(
        baseMessages,
        processedMessagesToAdd,
        {
          shouldSort: isHistory,
        },
      );

      // Propagate status updates to messages in the same attachment group
      // This ensures text and images sent together have synchronized status
      const statusUpdateMap = new Map(); // serverId -> messageStatus
      processedMessagesToAdd.forEach((msg) => {
        if (msg.serverId && msg.messageStatus) {
          statusUpdateMap.set(msg.serverId, msg.messageStatus);
        }
      });

      if (statusUpdateMap.size > 0) {
        return merged.map((msg) => {
          // If this message has a serverId that received a status update
          if (msg.serverId && statusUpdateMap.has(msg.serverId)) {
            return {
              ...msg,
              messageStatus: statusUpdateMap.get(msg.serverId),
            };
          }
          // Also check if message ID matches a serverId (for the text message)
          if (msg.id && statusUpdateMap.has(msg.id)) {
            return {
              ...msg,
              messageStatus: statusUpdateMap.get(msg.id),
            };
          }
          return msg;
        });
      }

      return merged;
    });

    if (isHistory && agentMessageIdsNeedingStatusUpdate.length > 0) {
      console.log(
        "[HistoryStatus] Queuing last 10 agent messages for status promotion to READ",
        {
          workitemId: currentWorkitemId,
          count: agentMessageIdsNeedingStatusUpdate.length,
        },
      );
      updateHistoryAgentMessageStatuses(agentMessageIdsNeedingStatusUpdate);
    }

    setIsFetchingMessages(false);
  };

  const parseMessagesForTimeStamps = (messagesList) => {
    let messageList = [];
    let datePointer = null;
    let messages = messagesList.filter((i) => !i.syntheticDateInfoMessage); // Filter out synthetic date info messages.
    let messageIds = messages.map((i) => i.id);
    messages.forEach((message, index) => {
      // if (message?.id === "session-close-message") {
      //   return;
      // }

      if (
        !(
          datePointer &&
          isOnSameDay(datePointer, message?.message?.sentTimestamp / 1000)
        )
      ) {
        let messageDateTimeText = dayjs
          .unix(message?.message?.sentTimestamp / 1000)
          .format("DD MMM YYYY");
        if (messageIds.indexOf(messageDateTimeText) === -1) {
          messageList.push({
            message: {
              text: messageDateTimeText,
              sentTimestamp: message.message.sentTimestamp,
            },
            id: messageDateTimeText,
            type: MessageType.info,
            timestamp: message.message.sentTimestamp,
            syntheticMessage: true,
            syntheticDateInfoMessage: true,
          });
          datePointer = message.message.sentTimestamp / 1000;
        } else {
        }
      }
      message.type = parseMessageType(message.creator, index);

      messageList.push(message);
    });
    if (!isActiveConversation()) {
      // Add session close message, if current session is closed.
      let sessionCloseMessage = getSessionCloseMessage();
      if (
        sessionCloseMessage &&
        s360ConfigService?.config?.configDetails?.startNewSession
      ) {
        messageList.push(sessionCloseMessage);
      }
    }

    return messageList;
  };

  const parseMessageType = (creator, index) => {
    if (creator === "CUSTOMER") {
      return MessageType.sent;
    } else if (creator === "BOT" || creator === "AGENT") {
      return MessageType.received;
    } else {
      if (index === 1) {
        //to see that 1st message is not from csutomer as everytime customer's type will be SENT
        return MessageType.received;
      } else {
        return MessageType.info;
      }
    }
  };

  // MARK : New Ccnversation
  let doMoveToNewConversation = false;
  const startNewConversation = () => {
    s360ConfigService.agentConnected = false;
    window.parent.postMessage(
      {
        resetFromNewButton: "true",
      },
      "*",
    );
    localStorage.setItem("autoOpenChat", "true");
  };

  // const onCreateSessionResponse = (newSessionResponse) => {
  //   if (doMoveToNewConversation) {
  //     props.actions.startConversation(newSessionResponse, () => {
  //       setMessages([]);
  //
  //       setXmppMessageHistory([]);
  //       setIsConversationClosed(false);
  //       setShowSnackBar(false);
  //       setShowSendChatTranscriptForm(false);
  //     });
  //   }
  // };

  let agentHealthPingTimerId = null;

  //NOTE : Enhancement 5
  const startFetchingHealthPings = () => {
    if (healthPingCounter > 2) {
      setShowReloadPopup(true);
    } else {
      healthPingCounter++;
      if (!isActiveConversation()) {
        return;
      }
      let sessionId = props.activeConversation.sessionId;
      if (!sessionId) {
        HWLog.warn("No Session Id Available To Fetch Agent Health Ping: ");
        return;
      }
    }
  };

  const removeHelathPingTimer = () => {
    if (agentHealthPingTimerId) {
      clearInterval(agentHealthPingTimerId);
    }
  };

  //  GREEN - Online
  //  RED - Offline
  //  Yellow - Away
  const parseAgentStatusPingResponse = (message) => {
    healthPingCounter--;
    let sessionId = message.sessionId || "";
    let activeSessionInfo = props.activeConversation || {};
    if (activeSessionInfo.sessionId !== sessionId) {
      HWLog.info(
        "Invalid Session Id: For Agant Health Ping Response: ",
        message || {},
      );
      return;
    }
    let status = (message.onlineStatus && message.onlineStatus.status) || "";
    let isValidStatus = ["GREEN", "RED", "Yellow"].indexOf(status) !== -1;
    if (!isValidStatus) {
      HWLog.info("Invlaid Ping Status From Server: ", message || {});
      return;
    }
    HWLog.info("AGENT PING STATUS: " + status);
    setAgentPingStatus(status);
  };

  // MARK: Actions
  const actions = {
    sendMessage: (message, wrkitemID) => sendMessage(message, wrkitemID),
    sendMessageWithAttachemnts: (files, textMessage) =>
      sendMessageWithAttachemnts(files, textMessage),
    sendTypingStatus: (typing) => sendTypingStatus(typing),
    sendMessageWithCode: (textMessage, dispalyMessage) =>
      sendMessageWithCode(textMessage, dispalyMessage),
    disableOnAgentConnections: () => disableOnAgentConnections(),
    handleShowReloadPopup: () => handleShowReloadPopup(),
  };

  const handleShowReloadPopup = () => {
    if (props?.config?.healthCheck) {
      setShowReloadPopup(true);
      setShowLoaderBotPopup(false);
    }
  };

  const sendTypingStatus = (typing) => {
    let sessionId =
      props.activeConversation && props.activeConversation.sessionId;
    if (!sessionId) {
      return;
    }
    HWLog.info("TYPING STATUS CHANGE: " + typing);
    xmppService.sendTypingIndicatorStatus(sessionId, typing).catch((error) => {
      HWLog.error(error, "Could not send typing status.");
    });
  };

  const checkEmoji = (textMessage) => {
    if (!textMessage) return;
    const regexpEmojiPresentation = /\p{Emoji_Presentation}/gu;
    const regex =
      /([\p{Alphabetic}\p{Mark}\p{Decimal_Number}\p{Connector_Punctuation}\p{Join_Control}]+)/gu;
    const specialChar = /[-[\]{}()*+!<=:?./\\^$|#\s,]/g;

    if (
      textMessage.match(regexpEmojiPresentation) != null &&
      textMessage.match(regexpEmojiPresentation).length === 1
    ) {
      if (
        textMessage.match(regex) == null &&
        textMessage.match(specialChar) == null
      ) {
        return true;
      }
    }
    return false;
  };

  const decideInputBoxBehaviour = useMemo(() => {
    console.log(
      "isAiBot:",
      isAiBot,
      "messages.length:",
      messages.length,
      "showCloseDialog:",
      showCloseDialog,
      "showInputBox:",
      showInputBox,
      "showNcxChatHistory:",
      showNcxChatHistory,
      "messages:",
      messages,
      "hideInputForHisry:",
      hideInputForHisry,
      "s360ConfigService.config.sandBox:",
      s360ConfigService.config.sandBox,
      "s360ConfigService.agentConnected:",
      s360ConfigService.agentConnected,
      "isAgentConnected:",
      isAgentConnected,
    );
    if (props.conversation?.fromHistory) return false;
    if (s360ConfigService.config.privacy) {
      return false;
    }
    if (s360ConfigService.config.sandBox) {
      return !showCloseDialog;
    }
    if (hideInputForHisry) return false;

    if (showCloseDialog) return false;
    if (showNcxChatHistory) return false;
    if (isAgentConnected) return true;
    if (s360ConfigService.agentConnected) return true;
    if (messages.length === 0) return true;
    const hasBotMessage = messages.some(
      (msg) => msg.userType === "BOT" || msg.creator === "BOT",
    );

    if (!hasBotMessage) return true;

    if (isAiBot) return true;
    return (
      showInputBox &&
      !showCloseDialog &&
      !showNcxChatHistory &&
      !hideInputForHisry
    );
  }, [
    isAiBot,
    messages.length,
    showCloseDialog,
    showInputBox,
    showNcxChatHistory,
    messages,
    hideInputForHisry,
    s360ConfigService.config.sandBox,
    s360ConfigService.agentConnected,
    isAgentConnected,
  ]);

  const sendMessage = (textMessage, isBot = false, showText = false) => {
    s360ConfigService.config.historyMessages = false;
    if (s360ConfigService.config.notification.isEnabled && playSound) {
      audio?.play();
    }

    setTimeout(() => setIsFetchingMessagesBelow(false), loaderTimeOut);

    let type = "TEXT";
    let initialId = new Date().getTime(); // Temporary ID *before* API call

    let newMessageComponents = [
      {
        subType: "default",
        text: showText ? showText : textMessage,
        category: "display",
        type: "text",
        richText: "",
      },
    ];

    if (isAiBot) {
      newMessageComponents.push({
        category: "input",
        type: "text",
        validation: {},
      });
    }

    // Creating the message object with a *temporary* ID
    let newMessageToSend = {
      sourceId: "chat",
      modifiedAt: initialId,
      channel: "CHAT",
      messageMediaType: "CUSTOM",
      message: JSON.stringify({ components: newMessageComponents }),
      workitemId: workitemIdArrays[workitemIdArrays.length - 1],
      toUser: !s360ConfigService?.config?.preview && {
        name: s360ConfigService?.thrioConfig?.formDetails?.Email,
        userName: s360ConfigService?.thrioConfig?.formDetails?.Email,
      },
      createdAt: initialId,
      uid: `reply_${initialId}`,
      messageType: "PRIVATE_MESSAGE",
      userType: "USER",
      id: `reply_${initialId}`, // *Temporary* ID
      messageStatus: [{ status: "SENT" }], // Initialize with SENT status
    };

    let messageForInternalUse = {
      message: {
        text: showText ? showText : textMessage,
        sentTimestamp: initialId,
        id: initialId, // *Temporary* ID
      },
      id: initialId, // *Temporary* ID
      type: "SENT",
      timestamp: initialId,
      convoType: type,
      creator: "CUSTOMER",
      userType: "USER",
      syntheticMessage: true,
      isFormatted: true,
      messageStatus: [{ status: "SENT" }],
    };

    let pendingMsg = { ...setMsgValue };
    setMessageLoader(true);
    setIsFetchingMessagesBelow(true);
    setShowMessagesFromStart(false);
    setShowAckMsg(true);
    setSetMsgValue({ ...pendingMsg, [initialId]: messageForInternalUse });

    // Add to UI *before* API call, using the temporary ID:
    addMessagesToList([newMessageToSend]);

    if (!s360ConfigService.config.preview) {
      if (currentWorkitemId) {
        s360ConfigService?.activeSessions[currentWorkitemId]?.chatMessages.push(
          messageForInternalUse,
        );
      }

      const fd = {
        fromId: s360ConfigService.thrioConfig?.formDetails?.Email || "",
        toId: currentWorkitemId,
        type: "CLIENT",
        textMsg: textMessage, // Send the raw text message
      };

      // *** IMPORTANT:  Make sure apiService.sendMessage returns the *full* response ***
      apiService
        .sendMessage(fd, currentWorkitemId)
        .then((response) => {
          const actualId = response.data.id; // Get the *real* ID from the API

          // Update the message in the UI with the *actual* ID:
          setMessages((prevMessages) => {
            const updatedMessages = prevMessages.map((msg) => {
              // Important: Match on the *temporary* ID.
              if (msg.id === `reply_${initialId}`) {
                return { ...msg, id: actualId, uid: actualId }; // Replace temp ID with real ID
              }
              return msg;
            });
            return updatedMessages;
          });

          // Update setMsgValue (if needed)
          setSetMsgValue((prevMsgValue) => {
            const updatedMsgValue = { ...prevMsgValue };
            if (updatedMsgValue[initialId]) {
              updatedMsgValue[actualId] = {
                ...updatedMsgValue[initialId],
                id: actualId,
                message: {
                  ...updatedMsgValue[initialId].message,
                  id: actualId,
                },
              };
              delete updatedMsgValue[initialId]; // Clean up the temporary ID entry
            }
            return updatedMsgValue;
          });

          //Update the session's chat messages
          // if (currentWorkitemId) {
          //   s360ConfigService.activeSessions[currentWorkitemId].chatMessages =
          //     s360ConfigService.activeSessions[
          //       currentWorkitemId
          //     ].chatMessages.map((msg) => {
          //       if (msg.id === initialId) {
          //         return {
          //           ...msg,
          //           id: actualId,
          //           message: { ...msg.message, id: actualId },
          //         };
          //       }
          //       return msg;
          //     });
          // }
          setMessageLoader(false);
          setIsFetchingMessagesBelow(false);
        })
        .catch((error) => {
          console.error("Error sending message:", error);
          setMessageLoader(false);
          setIsFetchingMessagesBelow(false);
          // Handle errors (e.g., show an error message to the user)
        });
    } else {
      // handle for preview
      setMessageLoader(false);
      setIsFetchingMessagesBelow(false);
    }
  };

  const handleCustomerRetryMsg = (msg) => {
    let message = { ...msg.message };
    let sessionInfo = props.activeConversation;

    setIsFetchingMessagesBelow(true);
    setShowMessagesFromStart(false);
    setShowAckMsg(true);

    timerLoader(1000);
  };

  const timerLoader = (time) => {
    setIsFetchingMessagesBelow(true);
    setTimeout(() => setIsFetchingMessagesBelow(false), time);
  };

  const parseFileTypeToSend = (file) => {
    if (file.mediaMimeType?.toLowerCase().indexOf("audio") !== -1) {
      return ConvoType.AUDIO;
    } else if (file.mediaMimeType?.toLowerCase().indexOf("video") !== -1) {
      return ConvoType.VIDEO;
    } else if (file.mediaMimeType?.toLowerCase().indexOf("image") !== -1) {
      return ConvoType.IMAGE;
    } else {
      return ConvoType.DOCUMENT;
    }
  };

  const isImageType = (fileType) => {
    if (fileType.includes("image/")) {
      return "IMAGE";
    } else {
      return "FILE";
    }
  };

  const sendMessageWithAttachemnts = (attachedFiles, textMessage) => {
    setSendingAttachementsLoader(true);
    setShowProcessingAttachementLoader(false);

    const processingTimer = setTimeout(() => {
      setShowProcessingAttachementLoader(true);
    }, 3000);

    s360ConfigService.config.historyMessages = false;
    let messageAttachments = [];
    let sentTimestamp = new Date().getTime();
    if (
      s360ConfigService.config.preview &&
      s360ConfigService?.config?.previewSessionId
    ) {
      const formData = new FormData();

      attachedFiles.forEach((file, i) => {
        let mediaMessage = {
          message: JSON.stringify({
            components: [
              {
                type: "file",
                subType: "default",
                attachmentTitle: file.name,
                category: "display",
                sentTimestamp: sentTimestamp, // Current timestamp
                id: "chat_ " + sentTimestamp + i, // Unique ID for the message
                url: URL.createObjectURL(file),
                attachmentMimeType: file.type,
                attachmentType: isImageType(file.type),
                attachedSize: file.size,
              },
            ],

            // Create a URL for the file
          }),
          userType: "CUSTOMER",
          messageMediaType: "CUSTOM",
          id: "chat_ " + sentTimestamp + i, // Same unique ID
          type: MessageType.sent, // Message type
          timestamp: sentTimestamp, // Timestamp for the message
          convoType: parseFileTypeToSend(file), // Determine the type (image, video, etc.)
          creator: "CUSTOMER", // Who created the message
          createdAt: sentTimestamp,
          messageStatus: [{ status: "SENT" }], // Initialize with SENT status
          // syntheticMessage: true, // Optional: Use if needed for synthetic messages
        };

        // Push the mediaMessage to messageAttachments
        messageAttachments.push(mediaMessage);
        formData.append("file", file);
        // Add the actual file object
      });
      let tempPreviewSessionID = decodeURIComponent(previewSessionID);
      // Add additional fields required by the API
      formData.append(
        "object",
        JSON.stringify({
          previewSessionId: tempPreviewSessionID, // Replace with the actual session ID
          message: {
            textMsg: "",
          },
        }),
      );
      apiService
        .sendPreviewDataFiles(formData, tempPreviewSessionID)
        .then((response) => {})
        .catch((error) => {
          console.error("Error sending preview data:", error);
        })
        .finally(() => {
          clearTimeout(processingTimer);
          setSendingAttachementsLoader(false);
          setShowProcessingAttachementLoader(false);
        });
      addMessagesToList(messageAttachments);
      return Promise.resolve();
    } else {
      if (textMessage && attachedFiles?.length > 0) {
        sendMessage(textMessage, showText);
        textMessage = "";
      }
      setMessageLoader(true);
      setIsFetchingMessagesBelow(true);

      let sessionInfo = props.activeConversation;

      let messageTime = new Date();

      let id = messageTime.getTime();
      // const file = attachedFiles[0];

      let properties = {
        fromId: s360ConfigService?.thrioConfig?.formDetails?.Email,
        toId: currentWorkitemId,
        type: "CLIENT",
        textMsg: textMessage,
        configId: s360ConfigService.config._id,
      };

      // Add text message optimistically to UI before API call
      // Use a shared timestamp so we can link text and attachments together
      const sharedTimestamp = new Date().getTime();
      const textMessageTempId = textMessage ? `text_${sharedTimestamp}` : null;
      if (textMessage) {
        let textMessageObj = {
          message: JSON.stringify({
            components: [
              {
                subType: "default",
                text: textMessage,
                category: "display",
                type: "text",
                richText: "",
              },
            ],
          }),
          id: textMessageTempId,
          type: MessageType.sent,
          timestamp: sharedTimestamp,
          convoType: ConvoType.TEXT,
          creator: "CUSTOMER",
          userType: "USER",
          createdAt: sharedTimestamp,
          messageMediaType: "CUSTOM",
          messageStatus: [{ status: "SENT" }], // Initialize with SENT status
          attachmentGroupId: sharedTimestamp, // Link to attachment group
        };
        addMessagesToList([textMessageObj]);
      }

      // Send each file as a separate API call so each gets its own unique server ID
      if (attachedFiles?.length) {
        let completedCount = 0;
        const totalFiles = attachedFiles.length;
        let textIdUpdated = false;

        attachedFiles.forEach((file, i) => {
          const fileFormData = new FormData();
          // Only include textMsg for the first file to avoid duplicate text messages
          const fileProperties = {
            ...properties,
            textMsg: "",
          };
          fileFormData.append("object", JSON.stringify(fileProperties));
          fileFormData.append("file1", file);

          const fileSentTimestamp = new Date().getTime() + i; // Ensure unique timestamps

          apiService
            .sendMessage(fileFormData, currentWorkitemId)
            .then((res) => {
              console.log(
                `[AttachmentUpload] Server response ID: ${res.data.id} for file: ${file.name}`,
              );

              // Update text message ID with first response
              if (textMessage && textMessageTempId && !textIdUpdated) {
                textIdUpdated = true;
                setMessages((prevMessages) =>
                  prevMessages.map((msg) =>
                    msg.id === textMessageTempId
                      ? {
                          ...msg,
                          id: res.data.id,
                          serverId: res.data.id,
                          messageStatus:
                            res.data.messageStatus || msg.messageStatus,
                        }
                      : msg,
                  ),
                );
              }

              const attachment = res.data.attachments?.[0] || {
                title: file.name,
                mediaMimeType: file.type,
                mediaType: isImageType(file.type),
                mediaSize: file.size,
              };

              const mediaMessage = {
                message: JSON.stringify({
                  components: [
                    {
                      type: "file",
                      subType: "default",
                      attachmentTitle: attachment.title,
                      attachmentMimeType: attachment.mediaMimeType,
                      attachmentType: attachment.mediaType,
                      attachedSize: attachment.mediaSize,
                      category: "display",
                      sentTimestamp: fileSentTimestamp,
                      id: res.data.id,
                      url: apiService.getFile(
                        res.data.workitemId,
                        attachment.title,
                      ),
                    },
                  ],
                }),
                userType: "USER",
                messageMediaType: "CUSTOM",
                id: res.data.id,
                type: MessageType.sent,
                timestamp: fileSentTimestamp,
                convoType: parseFileTypeToSend(attachment),
                creator: "CUSTOMER",
                createdAt: fileSentTimestamp,
                messageStatus: res.data.messageStatus || [{ status: "SENT" }],
                attachmentGroupId: sharedTimestamp,
                serverId: res.data.id,
              };

              addMessagesToList([mediaMessage]);
            })
            .catch((error) => {
              console.error(
                `[AttachmentUpload] Failed to upload ${file.name}:`,
                error,
              );
            })
            .finally(() => {
              completedCount++;
              if (completedCount === totalFiles) {
                clearTimeout(processingTimer);
                setSendingAttachementsLoader(false);
                setShowProcessingAttachementLoader(false);
                setMessageLoader(false);
                setIsFetchingMessagesBelow(false);
              }
            });
        });
      }
      return Promise.resolve();
    }
  };

  const getSessionCloseMessage = () => {
    let sessionCloseMessage =
      props.config &&
      props.config.configDetails &&
      props.config.configDetails.sessionCloseMessage;
    if (!sessionCloseMessage) {
      HWLog.warn("Session Close Message Not Available In Config:");
      return null;
    }
    let messageTime = new Date();
    return {
      message: {
        text: sessionCloseMessage,
        sentTimestamp: messageTime.getTime(),
      },
      id: "session-close-message",
      type: MessageType.info,
      timestamp: messageTime.getTime(),
      convoType: "CLOSE",
      syntheticMessage: true,
    };
  };

  const containerStyle = () => {
    let config = props.config;
    return {
      ...config?.customDesign?.conversationPageContainer,
      height: localStorage.getItem("openInFullScreen") ? "85%" : "100%",
    };
  };

  const sendMessageWithCode = (textMessage, displayMessage) => {
    let messageTime = new Date();
    let id = messageTime.getTime();
    let newMessageToSend = {
      message: {
        text:
          typeof displayMessage === "object"
            ? displayMessage.name
            : displayMessage,
        sentTimestamp: id,
        id: id,
      },
      id: id,
      type: MessageType.sent,
      timestamp: id,
      convoType: "TEXT",
      creator: "CUSTOMER",
      syntheticMessage: true,
      messageStatus: [{ status: "SENT" }],
    };
    let sessionInfo = props.activeConversation;
    let message = {
      text:
        typeof displayMessage === "object" ? displayMessage.value : textMessage,
      sentTimestamp: id,
      id: id,
    };
    addMessagesToList([newMessageToSend]);
    let pendingMsg = { ...setMsgValue };

    setMessageLoader(true);
    setIsFetchingMessagesBelow(true);
    setSetMsgValue({ ...pendingMsg, [id]: newMessageToSend });
    setShowAckMsg(true);
  };

  const updateAudioFileinChat = (file) => {
    let id = new Date().getTime();
    let newMessageToSend = {
      message: {
        text: "",
        sentTimestamp: id,
        id: id,
        text: URL.createObjectURL(file),
      },
      id: id,
      type: MessageType.sent,
      timestamp: id,
      convoType: ConvoType.AUDIO,
      creator: "CUSTOMER",
      syntheticMessage: true,
      messageStatus: [{ status: "SENT" }],
    };
    addMessagesToList([newMessageToSend]);
    // s360ConfigService.activeSessions[
    //   props.conversation.workitemId
    // ].chatMessages.push(newMessageToSend);
  };

  const setGifValueToList = (value) => setSetMsgValue(value);

  const handleSessionReloadClose = () => setShowReloadPopup(false);

  const handleSessionReload = () => {
    if (props?.config?.healthCheck) {
      // setShowLoaderBotPopup(true);
      setShowErrorMsg("Please wait while fetching the messages");
      healthPingCounter = 0;
    }

    setMessages([]);
    fetchConversationHistoryCometd();
    setShowReloadPopup(false);
  };
  const muteNotification = (data) => {
    setPlaySound(data);
  };
  const state = {
    messages,
    xmppMessageHistory,
    previewFiles,
    isConversationClosed,
    showSnackBar,
    showSendChatTranscriptForm,
    showCloseDialog,
    isFetchingMessages,
    isReset,
    showGif,
    isLoading,
    finalValue,
    messageLoader,
    isFetchingMessagesBelow,
    showChatStatusLang,
    showChatStatusAttachment,
    disableLoader,
    customerAckObj,
    showAckMsg,
    setMsgValue,
    showReloadPopup,
    showLoaderBotPopup,
    showErrorMsg,
    agentPingStatus,
    showMessagesFromStart,
    snackBarMessage,
    open,
    isTyping,
  };

  const showMessageLoading = (creator) => {
    if (s360ConfigService.config.sandBox) {
      return;
    }
    if (s360ConfigService?.firstUserMessageSent) {
      if (isAiBot)
        return (
          <span style={{ padding: "0 2rem", fontStyle: "italic" }}>
            {defaultBrandIcon()} Thinking...
          </span>
        );
      if (creator === "BOT")
        // non AI bot
        return (
          <span style={{ padding: "0 2rem", fontStyle: "italic" }}>
            {defaultBrandIcon()} Typing...
          </span>
        );
      // return <ThreeDotLoadingWithKeyframes key={`${creator}-threedotoading`} />;
    }
  };

  const loaderOverlayClassName = `s360-loader-overlay${
    showLoaderBotPopup ? " s360-loader-overlay--visible" : ""
  }`;

  return (
    <div className="s360-conversation-page" id="s360-conversation-page">
      <div className={loaderOverlayClassName} aria-hidden={!showLoaderBotPopup}>
        <CircularProgress />
        {showErrorMsg ? (
          <p className="s360-loader-overlay__message">{showErrorMsg}</p>
        ) : null}
      </div>
      {!showCloseDialog && (
        <NetworkStatusPopup onReload={handleNetworkReload} />
      )}
      {!showLoaderBotPopup && (
        <>
          {!showNcxChatHistory && (
            <ConversationHeader
              setIsAppOpen={props.setIsAppOpen}
              sessionClosedbyAgent={sessionClosedbyAgent}
              showCloseDialog={showCloseDialog}
              // add a check here if user tries to close dont terminate automatically instead stop terminate api in  restartNCXConversation
              restartNCXConversation={() => {
                setSessionClosedbyAgent(false);
                setClosedBySystemTimeout(false);
                setShowCloseDialog(true);
              }}
              {...props}
              {...state}
              agentInfo={props?.agentInfo}
              termsAccepted={props.termsAccepted}
              playSound={playSound}
              muteNotification={(data) => muteNotification(data)}
              isActiveConversation={isActiveConversation}
              startNewConversation={startNewConversation}
              onSendChatTranscriptClick={onSendChatTranscriptClick}
              closeConversationClick={closeConversationClick}
              isShowToggle={showChatStatusLang}
              sessionId={props?.activeConversation?.sessionId}
              setShowNcxChatHistory={(v) => {
                setShowNcxChatHistory(v);
                setShowCloseDialog(false);
              }}
            />
          )}
          {termsAndConditionsDecider && (
            <NCXPrivacyPolicyCompact
              config={
                s360ConfigService?.config?.configDetails?.privacyPolicyDetails
              }
              onAccept={() => {
                localStorage.setItem(
                  `nextiva-widget-terms-acceptance-${s360ConfigService?.config?.widgetconfigId}`,
                  "true",
                );
                setAcceptedPrivacy(true);
              }}
            />
          )}
          {!s360ConfigService?.config?.sandBox && (
            <div
              style={{
                width: "100%",
                // height: "100%",
                display: showNcxChatHistory ? "block" : "none",
                zIndex: 2,
              }}
            >
              <ConversationHeader
                sessionClosedbyAgent={sessionClosedbyAgent}
                showCloseDialog={showCloseDialog}
                restartNCXConversation={() => setShowCloseDialog(true)}
                {...props}
                {...state}
                agentInfo={props?.agentInfo}
                termsAccepted={props.termsAccepted}
                playSound={playSound}
                muteNotification={(data) => muteNotification(data)}
                isActiveConversation={isActiveConversation}
                startNewConversation={startNewConversation}
                onSendChatTranscriptClick={onSendChatTranscriptClick}
                closeConversationClick={closeConversationClick}
                isShowToggle={showChatStatusLang}
                sessionId={props?.activeConversation?.sessionId}
                setShowNcxChatHistory={(v) => {
                  setShowNcxChatHistory(v);
                  setShowCloseDialog(false);
                }}
                showNcxChatHistory={showNcxChatHistory}
              />
              {!s360ConfigService?.config?.hideChatHis && (
                <Suspense fallback={<div>Loading history...</div>}>
                  <NCXChatHistoryLazy
                    showNcxChatHistory={showNcxChatHistory}
                    downloadInProgress={downloadInProgress}
                    onClickBack={(_) => setShowNcxChatHistory(false)}
                    downloadHistory={downloadHistory}
                  />
                </Suspense>
              )}
            </div>
          )}
          {showReloadPopup && props.activeConversation.active && (
            <ReloadSessionContainer
              handleSessionReload={() => handleSessionReload()}
              handleSessionReloadClose={() => handleSessionReloadClose()}
            />
          )}
          {showCloseDialog && (
            <NCXCloseConversation
              chatClosedExternally={chatClosedExternally}
              sessionClosedbyAgent={sessionClosedbyAgent}
              closedBySystemTimeout={closedBySystemTimeout}
              restartNCXConversation={restartNCXConversation}
              onCancelClose={() => {
                setShowCloseDialog(false);
              }}
              onConfirmClose={onEndChat}
              fromHistory={props.conversation?.fromHistory}
              onGoToLanding={goToLandingFromHistoryConversation}
              downloadChatTranscript={downloadChatTranscript}
              sessionId={props?.activeConversation?.sessionId}
              messages={messages}
            />
          )}
          {
            <div
              className={`s360-conversation-page-container${
                isFullScreen ? "-fs" : ""
              }`}
              id="conver"
              style={{
                ...containerStyle(),
                height: localStorage.getItem("openInFullScreen")
                  ? "85%"
                  : "100%",
                display: showNcxChatHistory ? "none" : "block",
              }}
            >
              {downloadInProgress && (
                <div
                  style={{
                    position: "absolute",
                    height: "inherit",
                    width: "inherit",
                    zIndex: "9999",
                    backgroundColor: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <CircularProgress />
                </div>
              )}
              <LoaderProviderWrapper>
                {
                  <Conversation
                    sandBoxedAgentInfo={props.sandBoxedAgentInfo}
                    sandBoxedReadreciept={props.sandBoxedReadreciept}
                    handleDeleteMessage={handleDeleteMessage}
                    onEditMessage={handleEditMessage}
                    isAiBot={isAiBot}
                    setShowInputBox={setShowInputBox}
                    setEnableAttachmentProp={(data) => {
                      setEnableAttachment(data);
                    }}
                    setFileParamsProp={(data) => {
                      setFileParams((_) => data);
                    }}
                    setInputSpecsProp={(data) => {
                      setInputSpecs((_) => data);
                    }}
                    enableAttachment={enableAttachment}
                    uploadFilesToPreview={uploadFilesToPreview}
                    showTextBox={(data) => {
                      setShowText(data);
                    }}
                    sendMessageToPreview={sendMessageToPreview}
                    disableLoader={disableLoader}
                    messagesLength={messages.length}
                    parseSessionClose={parseSessionCloseResponse}
                    isFetchingMessages={isFetchingMessages}
                    messageLoader={messageLoader}
                    messages={messages}
                    lastMessageRef={lastMessageRef}
                    actions={{ ...props.actions, ...actions }}
                    startNewConversation={startNewConversation}
                    isFetchingMessagesBelow={isFetchingMessagesBelow}
                    customerAckObj={customerAckObj}
                    handleCustomerRetryMsgProp={handleCustomerRetryMsg}
                    downloadInProgress={downloadInProgress}
                    pdfRef={targetRef}
                    hideInputForHisry={hideInputForHisry}
                    agentSandBoxInfo={
                      props.config.configDetails?.showAgentInfo || false
                    }
                    fromHistory={props.conversation?.fromHistory}
                    sessionId={props?.activeConversation?.sessionId}
                  />
                }
              </LoaderProviderWrapper>
            </div>
          }
          <div>
            {showGif && (
              <Popup
                handleClose={handleClose}
                addMessagesToList={addMessagesToList}
                addSetMsgValue={setGifValueToList}
                {...props}
              />
            )}
          </div>
          {inputSpecs &&
            inputSpecs.showLoadingFrom &&
            showMessageLoading(inputSpecs.showLoadingFrom)}
          {sendingAttachmentsLoader && !showProcessingAttachementLoader && (
            <span style={{ padding: "0 2rem", fontStyle: "italic" }}>
              {defaultBrandIcon()} Uploading attachments...
            </span>
          )}
          {sendingAttachmentsLoader && showProcessingAttachementLoader && (
            <span style={{ padding: "0 2rem", fontStyle: "italic" }}>
              {defaultBrandIcon()} Processing attachments...
            </span>
          )}
          {decideInputBoxBehaviour && !s360ConfigService.config.privacy && (
            <div className="input-and-homebutton-container">
              {!s360ConfigService?.getConfig().connectToNextiva &&
                s360ConfigService?.config?.configDetails?.showHome && (
                  <HomeOutlined
                    onClick={() => {
                      if (s360ConfigService.config?.sandBox) return;
                      if (s360ConfigService?.config?.preview) {
                        apiService.sendHomeMenuPreview(
                          s360ConfigService?.config?.previewSessionId,
                        );
                      } else {
                        apiService.sendHomeMenu(currentWorkitemId);
                      }
                    }}
                    fontSize="large"
                    sx={{
                      color: "#015feb",
                      marginLeft: "10px",
                      cursor: "pointer",
                    }}
                    data-testid={`${
                      s360ConfigService?.config?.connectToNextiva
                        ? DATA_TEST_ID_PREFIX_CONNECT_TO_NEXTIVA
                        : DATA_TEST_ID_PREFIX
                    }-${LIVECHAT_CLICK_EVENTS.INPUT_BOX_HOME_BUTTON_CLICK}`}
                  />
                )}
              {!s360ConfigService.config.privacy && (
                <InputBox
                  sandBoxedAttachment={props.sandBoxedAttachment}
                  uploadFilesToPreview={uploadFilesToPreview}
                  sendMessageToPreview={sendMessageToPreview}
                  {...props}
                  {...actions}
                  finalValue={finalValue}
                  ref={messageRef}
                  send={onMessageSend}
                  // disableInput={!!previewFiles?.length}
                  disableInput={false}
                  attchmentProps={{
                    showChatStatusAttachment: showChatStatusAttachment,
                    attachRef: file,
                    onClickAttachment: () => {
                      file.current.click();
                      file.current.value = "";
                    },
                    onChangeAttachment: onFileSelect,
                  }}
                  enableAttachment={enableAttachment}
                  setFileParamsProp={(data) => {
                    setFileParams(data);
                  }}
                  fileParams={fileParams}
                  fileSizeError={fileSizeError}
                  inputSpecs={inputSpecs}
                  updateAudioFileinChat={updateAudioFileinChat}
                  onRemovePreviewFile={onRemovePreviewFile}
                  onAddPreviewFile={onFileSelect}
                  files={previewFiles}
                  currentWorkitemId={currentWorkitemId}
                  sessionId={props.activeConversation?.sessionId}
                />
              )}
            </div>
          )}
          {showCloseDialog && (
            <div
              className={`s360-conversation-page-footer-container${
                isFullScreen ? "-fs" : ""
              }`}
            >
              {/* {!!previewFiles?.length && (
              <PreviewAttachmentFiles
                {...props}
                {...state}
                onRemovePreviewFile={onRemovePreviewFile}
                onAddPreviewFile={onFileSelect}
                files={previewFiles}
              />
            )} */}

              <DefaultFooter {...props} />
            </div>
          )}
          <Snackbar
            open={showSnackBar}
            onClose={handleSnackbarClose}
            message={snackBarMessage}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            key={"bottom-right-snackbar"}
            autoHideDuration={3000}
          />
          {showSendChatTranscriptForm && (
            <SendChatTranscriptForm
              {...props}
              {...state}
              onSendChatTranscript={sendChatTranscript}
              onClose={() => setShowSendChatTranscriptForm(false)}
            />
          )}
        </>
      )}
    </div>
  );
}

export default ConversationPage;
